import { animate, style, transition, trigger } from '@angular/animations';
import { ViewportScroller, formatDate } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { findIndex, Observable, Subject, take, takeUntil } from 'rxjs';
import { appMessages } from 'src/@order/commonData/app-messages';
import { bulkOrderModel } from 'src/@order/commonData/bulkOrderInitialize';
import {
  interRegionalOrderModel,
  DropoffModel,
  InterRegionalOrderModel,
} from 'src/@order/commonData/interRegionalOrderInitialize';
import {
  PACKAGESIZETYPE,
  countries,
  deliveryMethods,
  handlingMethods,
  bulkPackageSizes,
  handlingMethodsForRegional,
  cashSerive,
  interRegionalOrderPayment,
  interRegionalPackageSizes, // Add this import
} from 'src/@order/commonData/commonUiData';
import { ProgressBarService } from 'src/@order/components/progress-bar/progress-bar.service';
import { AddBulkDropoffDialogComponent } from 'src/@order/dialogs/add-bulk-dropoff-dialog/add-bulk-dropoff-dialog.component';
import { AddBusinessNameDialogComponent } from 'src/@order/dialogs/add-business-name-dialog/add-business-name-dialog.component';
import { ConfirmationDialogComponent } from 'src/@order/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ImportDropoffLocationsDialogComponent } from 'src/@order/dialogs/import-dropoff-locations-dialog/import-dropoff-locations-dialog.component';
import { InfoDialogComponent } from 'src/@order/dialogs/info-dialog/info-dialog.component';
import { NoDriverAvailableDialogComponent } from 'src/@order/dialogs/no-driver-available-dialog/no-driver-available-dialog.component';
import { PickupLocationsDialogComponent } from 'src/@order/dialogs/pickup-locations-dialog/pickup-locations-dialog.component';
import { PromoCodesDialogComponent } from 'src/@order/dialogs/promo-codes-dialog/promo-codes-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { DataService } from 'src/@order/services/data.service';
import { FacebookApiService } from 'src/@order/services/FacebookApi.service';
import { GoogleMapsService } from 'src/@order/services/geocode.service';
import { ComponentCanDeactivate } from 'src/app/core/auth/guards/pending-changes.guard';
import { interRegional } from 'src/app/utils/systemEnums';

@Component({
  selector: 'app-inter-regional',
  templateUrl: './inter-regional.component.html',
  styleUrls: ['./inter-regional.component.scss'],
  animations: [
    trigger('showHide', [
      transition(':enter', [
        style({ transform: 'translateY(-20px)', opacity: 0 }),
        animate(200, style({ transform: 'translateY(0px)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate(200, style({ transform: 'translateY(-20px)', opacity: 0 })),
      ]),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }), // Initial state
        animate('300ms ease-in', style({ opacity: 1 })), // Fade in
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 })), // Fade out
      ]),
    ]),
  ],
})
export class InterRegionalComponent
  implements OnInit, OnDestroy, ComponentCanDeactivate
{
  @ViewChild('pickupDrawer') pickupDrawer: MatDrawer;

  form!: FormGroup;
  headings = {
    packageDestination: `What's Your package destination?`,
    pickupLocation: `Pickup Location`,
    dropOffLocation: `Dropoff Location`,
  };
  private unsubscribe$ = new Subject<void>();
  country = localStorage.getItem('country');
  userID = JSON.parse(localStorage.getItem('authUser')).id;

  customerData;
  isConfirmingOrder: boolean = false;
  deliveryMethods = JSON.parse(JSON.stringify(deliveryMethods));
  handlingMethods = JSON.parse(JSON.stringify(handlingMethodsForRegional));
  deliveryMethodsFire: any = [];
  handleWithCare: any;
  packagedItem: any;
  heavyItem: any;
  countries = JSON.parse(JSON.stringify(countries));
  selectedCountryCode: string;
  selectedCountry;
  indexOld;
  selectedIndex: number = 0;
  handlingData;
  handlingAllData: any; // This should contain package, care, heavy, etc. data
  selectedHandlingMethod: any;
  selectedHandlingItem: any;
  docIdFire: string = '';
  selectedDeliveryMethod: any;
  isPickupDrawerOpen = false;
  // Flag to control loading state of payment data
  isLoadingPaymentData: boolean = true;
  hardReload: boolean = false;
  isDropoffAdded: boolean = false;
  paymentMethods = JSON.parse(JSON.stringify(interRegionalOrderPayment));
  cashSerive = JSON.parse(JSON.stringify(cashSerive)); // Add this property
  selectedCashService: any = null; // Add this property
  currentTime = new Date();
  promoCodeList: [] = [];
  orderDoc;

  isDataLoading: boolean = false;
  detectClosingWindow: boolean = false;
  confirmOrderRes: any;
  orderConfirmApiCalled: boolean = false;
  isOrderConfirmed: boolean = false;
  coverFeePercent: number = 0;
  isPharmacyOrder: boolean = false;
  isBusinessPartner: boolean = false;

  isDropLocationImporting: boolean = false;

  isPhlenutrustCheckEnabled: boolean = false;

  currentStep = 0;
  maxStep = 1; // Set this to the number of tabs - 1

  // Flag to control when changeStatus should be updated
  isReviewOrderClicked: boolean = false;

  packsizes: PACKAGESIZETYPE[] = JSON.parse(
    JSON.stringify(interRegionalPackageSizes)
  );
  isBusinessNameAdded: boolean = false;
  sectorList: [] = [];
  redirectByWA: boolean = false;
  pendingOrderData: any;
  importedDropoffLocations: any;

  // isAttachmentUploaded:boolean = false;
  // attachmentUploadedUrl:string;

  // UI state
  senderType: 'individual' | 'business' = 'individual';
  pickupType: 'door' | 'self' = 'door';
  dropoffType: 'door' | 'self' = 'door';
  // Hold the last selected pickup location object for dialog highlighting
  selectedPickupLocation: any = null;
  // Hold the last selected dropoff location object for dialog highlighting (individual)
  selectedDropoffLocation: any = null;
  deliveryPlan: 'express' | 'regular' | 'saver' | null = null;

  // Individual sender specific properties (from React code)
  selectedDeliveryPlan: any = null;
  selectedPackageSize: any = null;
  selectedPackage: any = null;
  trustCheck: boolean = false;
  securityCover: boolean = false;
  cashCollection: boolean = false;
  subtractDeliveryFee: boolean = false;
  subtractPickupFee: boolean = false;
  itemCost: number = 0;
  isItemCostUpdating: boolean = false;
  selectedPaymentMethod: any = null;

  // Payment summary properties (from React code)
  pool: any = null; // Firebase data for payment summary
  apiLoading: boolean = false;

  // Data arrays (should be replaced with real data)
  handlingOptions = [
    {
      id: 1,
      title: 'Packaged',
      icon: 'assets/images/icons/packaged.png',
      isSelected: false,
    },
    {
      id: 2,
      title: 'Handle with Care',
      icon: 'assets/images/icons/handle-care.png',
      isSelected: false,
    },
  ];
  packageItems = [
    {
      id: 1,
      title: 'Fruits',
      images: 'assets/images/icons/fruits.png',
      isSelected: false,
    },
    {
      id: 2,
      title: 'Furniture',
      images: 'assets/images/icons/furniture.png',
      isSelected: false,
    },
    {
      id: 3,
      title: 'HouseHold Items',
      images: 'assets/images/icons/household.png',
      isSelected: false,
    },
    {
      id: 4,
      title: 'Laptops/Computers',
      images: 'assets/images/icons/laptop.png',
      isSelected: false,
    },
    {
      id: 5,
      title: 'Documents',
      images: 'assets/images/icons/documents.png',
      isSelected: false,
    },
    {
      id: 6,
      title: 'Cloths/Fashion Accessories',
      images: 'assets/images/icons/cloths.png',
      isSelected: false,
    },
    {
      id: 7,
      title: 'Office Accessories',
      images: 'assets/images/icons/office.png',
      isSelected: false,
    },
    {
      id: 8,
      title: 'Warehouse Pickup',
      images: 'assets/images/icons/warehouse.png',
      isSelected: false,
    },
  ];

  recentDropoffLocations = [
    { name: 'Home', address: '12 Independence Avenue, Ridge, Accra' },
    { name: 'Warehouse A', address: '7 Labone Crescent, Labone, Accra' },
    { name: 'Tamale Depot', address: '1 Neoplan Station, Circle, Accra' },
    {
      name: 'Tech Park Office',
      address: '02 Makola Market Road, Accra Central',
    },
  ];

  drawerContext: { type: 'pickup' | 'dropoff'; dropoffIndex?: number } = {
    type: 'pickup',
  };

  excelColFields = [
    {
      id: 1,
      isAdded: 1,
      isRequired: 1,
      title: 'name',
      isDelete: 0,
      name: 'name',
      createField: 'name',
    },
    {
      id: 2,
      isAdded: 1,
      isRequired: 1,
      title: 'Country Code',
      isDelete: 0,
      name: 'Country Code',
      createField: 'Country Code',
    },
    {
      id: 3,
      isAdded: 1,
      isRequired: 1,
      title: 'Mobile Number',
      isDelete: 0,
      name: 'Mobile Number',
      createField: 'Mobile Number',
    },
    {
      id: 5,
      isAdded: 1,
      isRequired: 1,
      title: 'Package Contents',
      isDelete: 0,
      name: 'Package Contents',
      createField: 'Package Contents',
    },
    {
      id: 6,
      isAdded: 1,
      isRequired: 1,
      title: 'Package Size (kg)',
      isDelete: 0,
      name: 'Package Size (kg)',
      createField: 'Package Size (kg)',
    },
    {
      id: 7,
      isAdded: 1,
      isRequired: 0,
      title: 'Cash Collection',
      isDelete: 0,
      name: 'Cash Collection',
      createField: 'Cash Collection',
    },
    {
      id: 4,
      isAdded: 1,
      isRequired: 1,
      title: 'Drop-off Location',
      isDelete: 0,
      name: 'Drop-off Location',
      createField: 'Drop-off Location',
    },
    {
      id: 8,
      isAdded: 1,
      isRequired: 0,
      title: 'Delivery Plan',
      isDelete: 0,
      name: 'Delivery Plan',
      createField: 'Delivery Plan',
    },
    {
      id: 9,
      isAdded: 1,
      isRequired: 0,
      title: 'Dropoff Details',
      isDelete: 0,
      name: 'Dropoff Details',
      createField: 'Dropoff Details',
    },
  ];

  // Dropoff counter for business sender type
  dropoffCount = 2; // Minimum 2 dropoff locations required
  stepIndex: number = 0;

  // Add the getter instead:
  get dropoffLocations(): FormArray {
    if (!this.form) {
      console.error('Form is not initialized');
      return new FormArray([]);
    }
    const dropoffArray = this.form.get('dropoffLocations') as FormArray;
    if (!dropoffArray) {
      console.error('dropoffLocations FormArray is not found');
      return new FormArray([]);
    }
    return dropoffArray;
  }

  incrementDropoff() {
    if (this.dropoffCount < 50 && this.form && this.dropoffLocations) {
      this.dropoffCount++;
      this.addDropRow(this.dropoffCount - 1);

      // Update business dropoff model
      if (this.senderType === 'business') {
        this.updateBusinessDropoffModel();
        this.syncModelToFirebase();
      }
    }
  }

  decrementDropoff() {
    if (this.dropoffCount > 2 && this.form && this.dropoffLocations) {
      // Remove the last tab (index is dropoffCount - 1)
      const lastIndex = this.dropoffCount - 1;

      // Directly remove the tab without going through removeTab to avoid double decrement
      this.dropoffLocations.removeAt(lastIndex);
      this.showDropoffDetails.splice(lastIndex, 1);
      this.dropoffCount--;

      // Clean up tracking states for the removed dropoff
      delete this.isBusinessItemCostApplied[lastIndex];
      delete this.isBusinessSecurityCoverApplied[lastIndex];

      // Update business dropoff model
      if (this.senderType === 'business') {
        this.updateBusinessDropoffModel();
        this.syncModelToFirebase();
      }
      this.cdr.detectChanges();

      // Save updated data to localStorage
      this.saveDataInfoLocal();
    } else {
      this._matSnackBar.open('Minimum 2 dropoff locations are required', 'OK', {
        duration: 3000,
      });
    }
  }

  isCashCollection = false;
  showDropoffDetails: boolean[] = [];

  // Add new properties for Firebase data
  orderDetail: any = {};
  dropDetail: any[] = [];
  isPhlenuTrustCheckApplied: boolean = false;
  isCashCollectionApplied: boolean = false;
  orderDate: string = '';
  orderNumber: string = '';
  expectedDeliveryTime: string = '';
  pickupName: string = '';
  pickupPhone: string = '';
  pickupAddress: string = '';

  // Model for managing dropoff data
  dropoffModel: DropoffModel[] = [];
  orderModel: InterRegionalOrderModel;

  // Local storage properties
  private isRestoringFromLocal = false;
  isItemCostApplied: boolean = false; // Add this new property

  // Business flow item cost properties
  isBusinessItemCostUpdating: boolean = false;
  isBusinessItemCostApplied: { [key: number]: boolean } = {};
  isBusinessSecurityCoverApplied: { [key: number]: boolean } = {};

  // Attachment properties
  isAttachmentUploaded: boolean = false;
  attachmentUploadedUrl: string = '';

  // Add Firebase optimization properties
  private pendingFirebaseUpdates: any = {};
  private updateTimeout: any = null;
  private readonly UPDATE_DEBOUNCE_MS = 1000; // 1 second debounce
  private isUpdatingFirebase = false;

  tipText: string = '';

  constructor(
    private fb: FormBuilder,
    private _matDialog: MatDialog,
    private _geocodeService: GoogleMapsService,
    private _matSnackBar: MatSnackBar,
    private afs: AngularFirestore,
    private _authService: AuthServiceLocal,
    private cdr: ChangeDetectorRef,
    private _router: Router,
    private _dataService: DataService
  ) {
    if (localStorage.getItem('isBusinessPartner') == '1') {
      this.isBusinessPartner = true;
    } else {
      this.isBusinessPartner = false;
    }
  }
  canDeactivate: () => boolean | Observable<boolean> = () => {
    // returning false will show a confirm dialog before navigating away
    if (localStorage.getItem('PWAToken')) {
      if (
        this.form.get('pickupLocation')?.value &&
        !this.isConfirmingOrder &&
        !this.hardReload &&
        !this.orderConfirmApiCalled // Add this condition
      ) {
        // this.saveDataInfoLocal();
        return false;
      } else {
        this.deleteDocument();
        this.unsubscribeFromDocument();
        return true;
      }
    } else {
      return true;
    }
  };

  private async deleteDocument() {
    if (!this.docIdFire || this.docIdFire.trim() === '') {
      console.warn('docIdFire is empty or null, skipping document deletion');
      return;
    }

    try {
      const docSnapshot = await this.afs
        .collection(interRegional)
        .doc(this.docIdFire)
        .delete();
    } catch (error) {
      console.error('Error deleting Firebase document:', error);
    }
  }

  ngOnInit(): void {
    // Initialize country code first
    this.filterDeliveryMethodByCountry();

    // set country-specific tip text based on logged-in user
    this.setTipText();

    this.form = this.fb.group({
      pickupLocation: ['', [Validators.required]],
      dropoffLocation: ['', [Validators.required]],
      dropoffLocations: this.fb.array([]), // Initialize as empty array
      orderPackageSize: [''],
      selectedHandlingMethod: [''],
      selectedHandlingItem: [''],
      itemCost: [''],
      attachmentInfo: [''], // Add this for "Other" package item description
      attachment: [''], // Add this for file attachment
      isPhlenuCashApplied: [false], // Add this for Phlenu Cash toggle
      isScheduleDelivery: [''], // Add schedule delivery toggle
      scheduleDelivery: [''], // Add schedule delivery date/time
    });

    // Add schedule delivery form subscriptions
    this.setupScheduleDeliverySubscriptions();

    // Initialize handling data first
    this.initializeHandlingData().then(() => {
      // Initialize Firebase data properties
      this.initializeFirebaseData();

      // Initialize dropoff model
      this.initializeDropoffModel();

      // Check for existing localStorage data and restore if available
      this.checkAndRestoreLocalData();
      this.getCoverFeeValue();
      this.getWebDestinationsData();

      // Subscribe to Firebase document changes if docIdFire is available
      if (this.docIdFire) {
        this.subscribeDoc();
      }
    });
  }

  getWebDestinationsData() {
    const countryName = localStorage.getItem('country');
    this._authService
      .getWebDestinations({ country: countryName })
      .subscribe((res: any) => {
        localStorage.setItem('webDestinations', JSON.stringify(res.data));
      });
  }

  private setTipText(): void {
    const storedCountry = localStorage.getItem('country');
    const phoneCode = localStorage.getItem('phoneCode');
    const country = storedCountry
      ? storedCountry.trim()
      : phoneCode === '+233'
      ? 'Ghana'
      : 'Nigeria';

    if (country === 'Ghana') {
      this.tipText =
        'Tip: To avoid high prices, type the specific location in your area for example a town, city, or popular landmark not just the general area name.';
    } else {
      this.tipText =
        'Tip: To avoid high prices, type the specific location in your area for example a street, neighborhood, or popular landmark not just the broad area name.';
    }
  }

  // Setup schedule delivery form subscriptions
  private setupScheduleDeliverySubscriptions(): void {
    // Check is schedule Delivery update on firebase.
    this.form.get('scheduleDelivery').valueChanges.subscribe((res) => {
      if (res && this.form.get('isScheduleDelivery').value) {
        // update on firebase.
        const params = {
          isScheduled: 1,
          scheduleDate: res.toString(),
          time: this._dataService.dateFormate(res),
          changeStatus: 1,
        };
        console.log('params update on firebase', params);

        this.updateDocWithParams(params);
      }
    });

    // uncheck schedule delivery
    this.form.get('isScheduleDelivery').valueChanges.subscribe((res) => {
      if (!res) {
        const params = {
          isScheduled: 0,
          scheduleDate: '',
          time: this._dataService.dateFormate(this.currentTime),
          changeStatus: 1,
        };

        if (this.form.get('scheduleDelivery').value)
          this.form.get('scheduleDelivery').setValue('');

        this.updateDocWithParams(params);
      } else {
        if (!this.form.get('scheduleDelivery').value)
          this.form
            .get('scheduleDelivery')
            .setValue(new Date(this.currentTime));
      }
    });
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy');
    // this.saveDataInfoLocal();
    this.clearLocalStorage();
    this.unsubscribeFromDocument();

    // Clear any pending Firebase updates
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Force any pending updates before destroying
    if (Object.keys(this.pendingFirebaseUpdates).length > 0) {
      this.performBatchedUpdate();
    }

    if (
      !this.form.get('pickupLocation').value &&
      this.docIdFire &&
      this.docIdFire.trim() !== ''
    ) {
      try {
        this.afs
          .collection(interRegional)
          .doc(this.docIdFire)
          .valueChanges()
          .subscribe()
          .unsubscribe();
        this.deleteDocument();
      } catch (error) {
        console.error('Error in ngOnDestroy Firebase operations:', error);
      }
    }

    // Reset package sizes and selections
    this.packsizes = null;
    this.selectedPackageSize = null;

    // Reset methods arrays
    this.handlingMethods = [];
    this.deliveryMethods = [];
    this.paymentMethods = [];
    this.deliveryMethodsFire = [];

    // Reset promo codes
    this.promoCodeList = [];

    // Reset form
    this.form.reset();

    // Reset other component state

    this.selectedDeliveryMethod = null;
    this.selectedPaymentMethod = null;
    this.orderDoc = null;
    this.isConfirmingOrder = false;

    this.isDataLoading = false;
    this.docIdFire = null;
    this.senderType = 'individual';

    console.error = function () {};
  }

  private unsubscribeFromDocument() {
    // Unsubscribe from Firebase document
    if (this.unsubscribe$) {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
  }

  clearLocalStorage() {
    // Don't clear localStorage if order was successfully confirmed
    const preserveInterRegional =
      sessionStorage.getItem('PRESERVE_PENDING_INTERREGIONALORDERDATA') === '1';
    if (
      !this.isOrderConfirmed &&
      !this.orderConfirmApiCalled &&
      !preserveInterRegional
    ) {
      localStorage.removeItem('PENDINGINTERREGIONALORDERDATA');
      console.log('LocalStorage cleared for inter-regional order');
    } else {
      console.log('LocalStorage preserved - order was successfully confirmed');
    }
  }

  resetOrder() {
    // Reset form
    this.form.reset();

    // Reset schedule delivery specifically
    if (this.form?.get('isScheduleDelivery')?.value) {
      this.form?.get('isScheduleDelivery')?.setValue('');
      this.form?.get('scheduleDelivery')?.setValue('');
    }

    // Reset UI state
    this.senderType = 'individual';
    this.pickupType = 'door';
    this.dropoffType = 'door';
    this.deliveryPlan = 'regular';
    this.stepIndex = 0;
    this.dropoffCount = 2; // Minimum 2 dropoff locations required
    this.selectedIndex = 0; // Start with first location

    // Reset individual sender properties
    this.selectedDeliveryPlan = null;
    this.selectedPackageSize = null;
    this.selectedPackage = null;
    this.trustCheck = false;
    this.securityCover = false;
    this.cashCollection = false;
    this.subtractDeliveryFee = false;
    this.subtractPickupFee = false;
    this.isItemCostApplied = false;
    this.isBusinessItemCostUpdating = false;
    this.isBusinessItemCostApplied = {};
    this.isBusinessSecurityCoverApplied = {};
    this.selectedPaymentMethod = null;
    this.selectedCashService = null; // Reset cash service

    // Reset arrays
    this.dropoffLocations.clear();
    this.showDropoffDetails = [];
    this.dropoffModel = [];

    // Reset selections
    this.packsizes.forEach((item) => (item.isSelected = 0));
    this.handlingMethods.forEach((item) => (item.isSelected = 0));
    this.paymentMethods.forEach((item) => (item.isSelected = 0));
    this.cashSerive.forEach((item) => (item.isSelected = 0)); // Reset cash service selections

    // Clear localStorage
    this.clearLocalStorage();

    console.log('Order reset successfully');
  }

  // Call this when moving to step 2 and senderType is business
  initDropoffLocations() {
    if (!this.form || !this.dropoffLocations) {
      console.warn('Form not ready yet, cannot initialize dropoff locations');
      return;
    }

    this.dropoffLocations.clear();
    this.showDropoffDetails = [];

    // Ensure minimum 2 dropoff locations
    const locationsToCreate = Math.max(this.dropoffCount, 2);
    for (let i = 0; i < locationsToCreate; i++) {
      this.addDropRow(i);
    }

    // Update dropoff count if it was less than 2
    if (this.dropoffCount < 2) {
      this.dropoffCount = 2;
    }

    // Initialize dropoff model for business
    this.updateBusinessDropoffModel();
    this.syncModelToFirebase();

    // Initialize default handling items for business dropoff locations if handlingAllData is available
    if (this.handlingAllData) {
      this.initializeBusinessHandlingItems();
    }
  }

  // Initialize default handling items for business dropoff locations
  initializeBusinessHandlingItems() {
    if (this.dropoffLocations && this.dropoffLocations.controls.length > 0) {
      this.dropoffLocations.controls.forEach((control, index) => {
        // Set first handling method as selected by default
        const handlingItems = control.get('handlingItems')?.value;
        if (handlingItems && handlingItems.length > 0 && this.handlingAllData) {
          // Reset all selections first
          handlingItems.forEach((item: any) => (item.isSelected = 0));
        }
      });
    }
  }

  getDropDistance(id: string): number | string | undefined {
    return this.orderDoc?.dropDetails?.find((val) => val.id === id)
      ?.dropOffDistanceToDs;
  }

  addDropRow(i: number): void {
    // Check if this dropoff row already exists to prevent duplicates
    if (this.dropoffLocations.controls[i]) {
      console.log(`Dropoff row ${i} already exists, skipping creation`);
      return;
    }

    console.log(`Creating dropoff row ${i}`);

    const dropoffGroup = this.fb.group({
      contactPerson: [
        '',
        [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z0-9 ]*$')],
      ],
      personNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(
            this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
          ),
        ],
      ],
      dropoffPointAddress: ['', [Validators.required]],
      dropoffPoint: [''],
      packageSizes: [JSON.parse(JSON.stringify(interRegionalPackageSizes))],
      packageSize: [''],
      handlingItems: [JSON.parse(JSON.stringify(handlingMethodsForRegional))],
      selectedHandlingItem: [''],
      handlingSubItems: [[]],
      selectedSubItem: [''],
      attachmentInfo: [''],
      attachment: [''],
      attachmentUrl: [''],
      isAttachmentUploaded: [false],
      isCashCollected: [false],
      collectCash: [''],
      isPhlenuTrustCheckApplied: [false],
      isSecurityCoverApplied: [false],
      isDoorToDoorDropoff: [this.dropoffType === 'door'],
      landMark: [''],
      deliveryPlan: ['regular'],
      id: [Date.now().toString() + String(i)],
    });

    this.dropoffLocations.push(dropoffGroup);
    this.showDropoffDetails.push(false);

    console.log(
      `Successfully created dropoff row ${i}, total controls: ${this.dropoffLocations.length}`
    );

    // Initialize handling items for this new dropoff if handlingAllData is available
    if (this.handlingAllData && this.senderType === 'business') {
      setTimeout(() => {
        const control = this.dropoffLocations.controls[i];
        const handlingItems = control?.get('handlingItems')?.value;
        if (handlingItems && handlingItems.length > 0) {
          // Reset all selections first
          handlingItems.forEach((item: any) => (item.isSelected = 0));
          // Don't set any item as selected by default
          // handlingItems[0].isSelected = 1;
          // control.get('selectedHandlingItem')?.setValue(handlingItems[0]);

          // Don't initialize handlingSubItems with default since no handling method is selected
          // const defaultSubItems = this.addNewKey(this.handlingAllData?.package || []);
          // control.get('handlingSubItems')?.setValue(defaultSubItems);
          // console.log(`Default handling sub-items loaded for new dropoff ${i}:`, defaultSubItems);
        }
      }, 0);
    }
  }

  removeTab(dropIndex: number) {
    if (!this.form || !this.dropoffLocations) {
      console.warn('Form not ready yet, cannot remove tab');
      return;
    }

    // Prevent removal of first 2 dropoff locations
    if (dropIndex < 2) {
      this._matSnackBar.open(
        'Cannot remove the first 2 dropoff locations',
        'OK',
        { duration: 3000 }
      );
      return;
    }

    // Prevent removal if it would result in less than 2 dropoff locations
    if (this.dropoffLocations.length <= 2) {
      this._matSnackBar.open('Minimum 2 dropoff locations are required', 'OK', {
        duration: 3000,
      });
      return;
    }

    // Check if the form is dirty and show confirmation if needed
    const dropoffControl = this.dropoffLocations.controls[dropIndex];
    if (dropoffControl && dropoffControl.dirty) {
      this.deleteWithConfirmation(dropIndex);
    } else {
      this.deleteDropoffLocation(dropIndex);
    }
  }

  private deleteWithConfirmation(dropIndex: number): void {
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        heading: 'Alert!',
        headingColor: 'text-red',
        message:
          'Are you sure you want to remove this dropoff location? This action cannot be undone.',
        action: {
          ok: 'Remove',
          cancel: 'Cancel',
          align: 'left',
        },
      },
    });
    dialog.afterClosed().subscribe((res) => {
      if (res) {
        this.deleteDropoffLocation(dropIndex);
      }
    });
  }

  private deleteDropoffLocation(dropIndex: number): void {
    this.dropoffLocations.removeAt(dropIndex);
    this.showDropoffDetails.splice(dropIndex, 1);

    this.dropoffCount--;

    // Clean up tracking states for the removed dropoff
    delete this.isBusinessItemCostApplied[dropIndex];
    delete this.isBusinessSecurityCoverApplied[dropIndex];

    // Update dropoff model after removing tab
    if (this.senderType === 'business') {
      this.updateBusinessDropoffModel();
      this.syncModelToFirebase();
    }

    this._matSnackBar.open('Dropoff location removed successfully', 'OK', {
      duration: 2000,
    });
  }

  openImportDropoffDialog() {
    console.log('before open', this.excelColFields);

    const dialog = this._matDialog.open(ImportDropoffLocationsDialogComponent, {
      panelClass: ['commonDialogWrapper', 'importDropoffwrapper'],
      backdropClass: 'dialogBackdrop',
      // hasBackdrop : false,
      minHeight: '330px',
      autoFocus: false,
      data: {
        feilds: this.excelColFields,
        for: 'isForOrder',
        maxIndex: 50,
        isInterRegional: true,
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res?.length) {
        this.resetDropoffLocations();
        this.isDropLocationImporting = true;
        this.manageDropoff(res).catch((err) => {
          this.isDropLocationImporting = false;
        });
      }
    });
  }

  resetDropoffLocations() {
    console.log('[IMPORT] resetDropoffLocations called');
    this.importedDropoffLocations = [];

    if (this.form && this.dropoffLocations) {
      this.dropoffLocations.clear();
    }

    // Clear tracking states
    this.isBusinessItemCostApplied = {};
    this.isBusinessSecurityCoverApplied = {};

    // Initialize with minimum 2 dropoff locations for business flow
    if (this.senderType === 'business') {
      this.initDropoffLocations();
    } else {
      // For individual flow, create 2 default rows
      for (let i = 0; i < 2; i++) {
        this.addDropRow(i);
      }
    }

    this.selectedIndex = 0; // Set default tab index to first location
    console.log(
      '[IMPORT] Dropoff locations reset, new count:',
      this.dropoffLocations.length
    );
  }

  async manageDropoff(arr) {
    try {
      let tempArr = this.removeSpacesFromKeys(arr);
      tempArr = this.addLocationString(tempArr);

      // Ensure we have enough dropoff rows before processing
      const requiredRows = tempArr.length;
      const currentRows = this.dropoffLocations.length;

      console.log(
        `Required rows: ${requiredRows}, Current rows: ${currentRows}`
      );

      // Add rows if needed
      for (let i = currentRows; i < requiredRows; i++) {
        console.log(`Adding dropoff row ${i}`);
        await this.addDropRow(i);
      }

      console.log(
        `Final dropoff locations length: ${this.dropoffLocations.length}`
      );

      this.importedDropoffLocations = await Promise.all(
        tempArr.map(async (element: any, i: number) => {
          const dropAddress =
            element['DropoffLocation'] ||
            element['Drop-offLocation'] ||
            element['Drop-off Location'] ||
            element['Dropoff Location'] ||
            element['Drop Off Location'] ||
            element['DropOffLocation'] ||
            '';

          let geoLocation = null;
          if (dropAddress.trim()) {
            try {
              geoLocation = await this._geocodeService
                .geocodeAddress(dropAddress)
                .then((res) => res);
            } catch (error) {
              console.error('Geocoding error for address:', dropAddress, error);
            }
          }

          console.log('geoLocation', geoLocation);
          return { ...element, geoLocation };
        })
      );

      // Set form data for each imported location
      console.log(
        'Setting form data for imported locations:',
        this.importedDropoffLocations.length
      );
      this.importedDropoffLocations.forEach((item, i) => {
        console.log(`Processing item ${i}:`, item);
        if (this.dropoffLocations.at(i)) {
          console.log(`Form control exists for index ${i}, setting data`);
          this.setImportedDropOffDataForm(item, i);
        } else {
          console.error(`Form control does not exist for index ${i}`);
        }
      });

      this.isDropLocationImporting = false;
      console.log(
        '[IMPORT] Import completed, importedDropoffLocations:',
        this.importedDropoffLocations
      );

      // Update dropoff model after importing
      try {
        this.updateBusinessDropoffModel();
        this.syncModelToFirebase();
      } catch (error) {
        console.error('[IMPORT] Error updating business model:', error);
      }

      // Trigger validation updates for all dropoff locations
      console.log(
        '[IMPORT] Triggering validation updates for all dropoff locations'
      );
      this.dropoffLocations.controls.forEach((control, index) => {
        const addrCtrl = control.get('dropoffPointAddress');
        if (addrCtrl) {
          addrCtrl.updateValueAndValidity();
        }
        control.updateValueAndValidity();
      });

      // Force change detection to update UI and button state
      this.cdr.detectChanges();

      // Log validation state after import
      console.log('[IMPORT] Validation state after import:', {
        dropoffCount: this.dropoffLocations.length,
        canProceed: this.canProceedToNextStep(),
        validationDetails: this.dropoffLocations.controls.map(
          (control, index) => ({
            index: index + 1,
            address: control.get('dropoffPointAddress')?.value,
            hasDestinationError: control
              .get('dropoffPointAddress')
              ?.hasError('destinationNotFound'),
            valid: control.valid,
            errors: control.get('dropoffPointAddress')?.errors,
          })
        ),
      });

      // Check for failed geocoding
      const emptyLocationIndex = [];
      this.importedDropoffLocations.forEach((item, i) => {
        if (!item.geoLocation) emptyLocationIndex.push(i + 1);
      });

      if (emptyLocationIndex.length) {
        this._matSnackBar.open(
          `Couldn't fetch your drop-off  ${
            emptyLocationIndex.length > 1
              ? '(' + emptyLocationIndex.join(', ') + ')'
              : 1
          }. Please check again or Select them manually`,
          'OKAY',
          { duration: 10000 }
        );
      } else {
        this._matSnackBar.open(
          `Successfully imported ${this.importedDropoffLocations.length} dropoff locations`,
          'OKAY',
          { duration: 3000 }
        );
      }
    } catch (error) {
      console.error('Error in manageDropoff:', error);
      this.isDropLocationImporting = false;
      this._matSnackBar.open(
        'Error importing dropoff locations. Please try again.',
        'OKAY',
        { duration: 5000 }
      );
    }
  }

  removeSpacesFromKeys(array) {
    return array.map((obj) => {
      const newObj = {};
      Object.keys(obj).forEach((key) => {
        // Remove spaces from key names
        const newKey = key.replace(/\s+/g, '');
        newObj[newKey] = obj[key];
      });
      return newObj;
    });
  }

  addLocationString(arr) {
    return arr.map((item) => ({
      ...item,
      DropoffLocation: item['Drop-offLocation'],
    }));
    // return arr.map((item) => ({...item, DropoffLocation : item['Drop-offLocation']}))
  }

  // Validate an address string against webDestinations in localStorage
  private validateAddressAgainstWebDestinations(address: string): boolean {
    try {
      if (!address) {
        console.log(
          '[DEBUG] validateAddressAgainstWebDestinations: No address provided'
        );
        return false;
      }

      const webDestinations = JSON.parse(
        localStorage.getItem('webDestinations') || '[]'
      );
      console.log(
        '[DEBUG] validateAddressAgainstWebDestinations: webDestinations from localStorage:',
        webDestinations
      );

      if (!Array.isArray(webDestinations) || webDestinations.length === 0) {
        console.log(
          '[DEBUG] validateAddressAgainstWebDestinations: No valid webDestinations found'
        );
        return false;
      }

      const parts = String(address)
        .split(',')
        .map((p) => String(p).trim().toLowerCase())
        .filter((p) => !!p);

      console.log(
        '[DEBUG] validateAddressAgainstWebDestinations: Address parts:',
        parts
      );

      const destinationNames = webDestinations
        .map((d: any) =>
          String(d?.destination_name || '')
            .trim()
            .toLowerCase()
        )
        .filter((d: string) => !!d);

      console.log(
        '[DEBUG] validateAddressAgainstWebDestinations: Available destination names:',
        destinationNames
      );

      // Check if any destination name is contained within any address part
      const hasMatch = parts.some((part) => {
        const partMatches = destinationNames.some((dest) => {
          const contains = part.includes(dest);
          if (contains) {
            console.log(
              `[DEBUG] Found match: "${dest}" is contained in "${part}"`
            );
          }
          return contains;
        });
        return partMatches;
      });
      console.log(
        '[DEBUG] validateAddressAgainstWebDestinations: Has match:',
        hasMatch
      );

      return hasMatch;
    } catch (error) {
      console.log(
        '[DEBUG] validateAddressAgainstWebDestinations: Error:',
        error
      );
      return false;
    }
  }

  setImportedDropOffDataForm(item, index) {
    try {
      // Validate that the form control exists
      if (!this.dropoffLocations.at(index)) {
        console.error(`Dropoff location at index ${index} does not exist`);
        return;
      }

      const personName = String(item?.name || item?.Name || '');
      console.log(`Setting contact person for index ${index}:`, personName);
      this.dropoffLocations.controls[index]
        .get('contactPerson')
        .setValue(personName);

      // Set phone number early and consistently
      const mobileNumber =
        item?.MobileNumber ||
        item?.Mobile ||
        item?.PhoneNumber ||
        item?.Phone ||
        item?.ContactNumber ||
        item?.ContactNo;

      console.log(`Setting phone number for index ${index}:`, mobileNumber);
      if (mobileNumber) {
        const normalizedMobile = String(mobileNumber).trim();
        const finalMobile = this.phoneNumberTrim(normalizedMobile, index);
        this.dropoffLocations.controls[index]
          .get('personNumber')
          .setValue(finalMobile);
        console.log(`Final mobile for index ${index}:`, finalMobile);
      }

      if (item.geoLocation?.country == this.selectedCountry) {
        const timestamp = new Date();
        const dropoffpoint = {
          address: String(item?.geoLocation?.full_address) || '',
          countryCode: String(this.selectedCountryCode),
          dialCode: String(this.selectedCountryCode),
          fullAddress: '',
          id:
            this.orderDoc?.userId + '_' + timestamp.getTime() ||
            'temp_' + timestamp.getTime(),
          isPickup: Number(0),
          landmark: String(item?.geoLocation?.landMark) || '',
          latitude: Number(item?.geoLocation?.lat),
          locationId:
            this.orderDoc?.userId + '_' + timestamp.getTime() ||
            'temp_' + timestamp.getTime(),
          longitude: Number(item?.geoLocation?.lng),
          mobile: String(
            item?.MobileNumber || item?.Mobile || item?.PhoneNumber || ''
          ),
          name: personName,
          phone: String(
            item?.MobileNumber || item?.Mobile || item?.PhoneNumber || ''
          ),
          time: String(timestamp),
          timestamp: Number(timestamp.getTime()),
          updateAt: Number(timestamp.getTime()),
          userID: this.orderDoc?.userId || 'temp',
        };
        this.dropoffLocations.controls[index]
          .get('dropoffPoint')
          .setValue(dropoffpoint);
        this.dropoffLocations.controls[index]
          .get('dropoffPointAddress')
          .setValue(String(item?.geoLocation?.full_address));
      } else {
        if (item.geoLocation?.country)
          this._matSnackBar.open(
            `Your filled location is not in ${this.selectedCountry}. Please pick a place within ${this.selectedCountry}.`,
            'OKAY',
            { duration: 3000 }
          );
      }

      // Destination validation based on original excel address
      const excelAddress = String(
        item?.DropoffLocation ||
          item?.['Drop-offLocation'] ||
          item?.['Drop-off Location'] ||
          item?.['Dropoff Location'] ||
          item?.['Drop Off Location'] ||
          item?.['DropOffLocation'] ||
          ''
      ).trim();

      const addressControl = this.dropoffLocations.controls[index].get(
        'dropoffPointAddress'
      );
      if (addressControl) {
        console.log(
          `[IMPORT] Validating destination for dropoff ${index + 1}:`,
          excelAddress
        );

        // Clear any existing destinationNotFound error first
        const hadError = addressControl.hasError('destinationNotFound');
        if (hadError) {
          console.log(
            `[IMPORT] Clearing existing destinationNotFound error for dropoff ${
              index + 1
            }`
          );
          const { destinationNotFound, ...rest } = (addressControl.errors ||
            {}) as any;
          const newErrors = Object.keys(rest).length ? rest : null;
          addressControl.setErrors(newErrors);
        }

        const isValidDest =
          this.validateAddressAgainstWebDestinations(excelAddress);

        console.log(
          `[IMPORT] Destination validation result for dropoff ${index + 1}:`,
          {
            address: excelAddress,
            isValid: isValidDest,
          }
        );

        if (!isValidDest) {
          console.log(
            `[IMPORT] Setting destinationNotFound error for dropoff ${
              index + 1
            }`
          );
          const existingErrors = addressControl.errors || {};
          addressControl.setErrors({
            ...existingErrors,
            destinationNotFound: true,
          });
          addressControl.markAsTouched();
          addressControl.updateValueAndValidity();
        } else {
          // Ensure error is cleared if destination is valid
          if (addressControl.hasError('destinationNotFound')) {
            console.log(
              `[IMPORT] Clearing destinationNotFound error for valid destination at dropoff ${
                index + 1
              }`
            );
            const { destinationNotFound, ...rest } = (addressControl.errors ||
              {}) as any;
            const newErrors = Object.keys(rest).length ? rest : null;
            addressControl.setErrors(newErrors);
          }
          addressControl.updateValueAndValidity();
        }

        console.log(
          `[IMPORT] Address control state for dropoff ${index + 1}:`,
          {
            value: addressControl.value,
            errors: addressControl.errors,
            hasDestinationError: addressControl.hasError('destinationNotFound'),
            valid: addressControl.valid,
          }
        );
      }

      if (item['PackageSize(kg)']) {
        this.dropoffLocations.controls[index].get(
          'handlingItems'
        ).value[0].isSelected = 1;
        this.dropoffLocations.controls[index]
          .get('packageSizes')
          .value.forEach((packageSize) => (packageSize.isSelected = 0));
        const selectedpackageSize = this.dropoffLocations.controls[index]
          .get('packageSizes')
          .value.filter(
            (packageSize) =>
              String(packageSize.name).toLocaleLowerCase() ===
              String(item['PackageSize(kg)']).toLocaleLowerCase()
          )[0];

        if (selectedpackageSize) {
          selectedpackageSize.isSelected = 1;
          this.dropoffLocations.controls[index]
            .get('packageSize')
            .setValue(selectedpackageSize);
        } else {
        }
      }

      if (Number(item?.CashCollection) > 0) {
        const amount = Number(item?.CashCollection);
        this.dropoffLocations.controls[index]
          .get('isCashCollected')
          .setValue(true);
        this.dropoffLocations.controls[index]
          .get('collectCash')
          .setValue(amount);

        // Mark as applied and sync model so UI shows "Applied" without manual click
        this.isBusinessItemCostApplied[index] = true;
        try {
          this.updateBusinessDropoffModel();
          this.updateSpecificDropoffInModel(index, {
            collectCash: amount,
            isCashCollected: true,
          });
          this.syncModelToFirebase();
        } catch (e) {
          console.warn('Failed to auto-apply business item cost on import', e);
        }
      }

      if (item?.geoLocation?.landMark)
        this.dropoffLocations.controls[index]
          .get('landMark')
          .setValue(item?.geoLocation?.landMark);

      if (item?.PackageContents) {
        console.log(
          `Setting package contents for index ${index}:`,
          item?.PackageContents
        );

        // First, ensure we have handling items and sub-items initialized
        const handlingItems =
          this.dropoffLocations.controls[index].get('handlingItems').value;
        let handlingSubItems =
          this.dropoffLocations.controls[index].get('handlingSubItems').value;

        // Load ALL sub-items from both handling methods for comparison
        let allSubItems = [];
        if (this.handlingAllData) {
          // Combine both package and care items for comprehensive matching
          const packageItems = this.addNewKey(
            this.handlingAllData?.package || []
          );
          const careItems = this.addNewKey(this.handlingAllData?.care || []);
          allSubItems = [...packageItems, ...careItems];
          console.log(`All available sub-items for matching:`, allSubItems);
        }

        if (allSubItems && allSubItems.length > 0) {
          console.log(
            `Available sub-items for matching index ${index}:`,
            allSubItems
          );

          // Try to find exact match first
          console.log(
            `Looking for exact match for "${item?.PackageContents}" in ${allSubItems.length} items`
          );
          const exactMatch = allSubItems.find((subItem) => {
            const match =
              String(subItem.title).toLowerCase() ===
              String(item?.PackageContents).toLowerCase();
            if (match) {
              console.log(
                `Found exact match: "${subItem.title}" === "${item?.PackageContents}"`
              );
            }
            return match;
          });

          if (exactMatch) {
            console.log(`Found exact match for index ${index}:`, exactMatch);

            // Determine which handling method this sub-item belongs to
            let selectedHandlingIndex = 0; // Default to first (Packaged)
            let targetSubItems = [];

            // Check if this sub-item belongs to care items
            if (this.handlingAllData?.care) {
              const careItems = this.handlingAllData.care;
              const isCareSubItem = careItems.some(
                (careItem) =>
                  careItem.id === exactMatch.id ||
                  careItem.title === exactMatch.title
              );

              if (isCareSubItem) {
                selectedHandlingIndex = 1; // Select "Handle With Care"
                targetSubItems = this.addNewKey(
                  this.handlingAllData?.care || []
                );
                console.log(
                  `Sub-item belongs to care items, selecting Handle With Care`
                );
              } else {
                targetSubItems = this.addNewKey(
                  this.handlingAllData?.package || []
                );
                console.log(
                  `Sub-item belongs to package items, selecting Packaged`
                );
              }
            } else {
              targetSubItems = this.addNewKey(
                this.handlingAllData?.package || []
              );
            }

            // Set the handling method
            if (handlingItems && handlingItems.length > selectedHandlingIndex) {
              handlingItems.forEach(
                (item, i) =>
                  (item.isSelected = i === selectedHandlingIndex ? 1 : 0)
              );

              // Create a deep copy to ensure Angular detects the change
              const updatedHandlingItems = JSON.parse(
                JSON.stringify(handlingItems)
              );

              // Update the form control with the modified array first
              this.dropoffLocations.controls[index]
                .get('handlingItems')
                .setValue(updatedHandlingItems);

              // Then set the selected handling item
              this.dropoffLocations.controls[index]
                .get('selectedHandlingItem')
                .setValue(updatedHandlingItems[selectedHandlingIndex]);

              console.log(
                `Updated handlingItems for index ${index}:`,
                handlingItems
              );

              // Debug: Check if isSelected was actually set
              console.log(
                `Handling items after update:`,
                handlingItems.map((item) => ({
                  title: item.title,
                  isSelected: item.isSelected,
                }))
              );
            }

            // Set the appropriate sub-items
            this.dropoffLocations.controls[index]
              .get('handlingSubItems')
              .setValue(targetSubItems);

            // Find and select the matching sub-item in the target list
            const matchingIndex = targetSubItems.findIndex(
              (subItem) =>
                subItem.id === exactMatch.id ||
                subItem.title === exactMatch.title
            );

            if (matchingIndex !== -1) {
              // Get the current form control value
              const currentSubItems =
                this.dropoffLocations.controls[index].get(
                  'handlingSubItems'
                ).value;

              // Use the same pattern as onSelectPackagedItemForBusiness
              currentSubItems.forEach((item: any, index: number) => {
                item.isSelected = index === matchingIndex ? 1 : 0;
              });

              // Create a deep copy to ensure Angular detects the change
              const updatedSubItems = JSON.parse(
                JSON.stringify(currentSubItems)
              );

              // Set the selected sub item
              this.dropoffLocations.controls[index]
                .get('selectedSubItem')
                .setValue(updatedSubItems[matchingIndex]);

              // Update the form control with the modified array
              this.dropoffLocations.controls[index]
                .get('handlingSubItems')
                .setValue(updatedSubItems);

              // Trigger change detection to update the UI
              this.cdr.detectChanges();

              console.log(
                `Selected sub-item for index ${index}:`,
                currentSubItems[matchingIndex]
              );

              // Debug: Check if sub-item isSelected was actually set
              console.log(
                `Sub-items after selection:`,
                currentSubItems.map((item) => ({
                  title: item.title,
                  isSelected: item.isSelected,
                }))
              );
            }
          } else {
            // Try partial match
            const partialMatch = allSubItems.find(
              (subItem) =>
                String(subItem.title)
                  .toLowerCase()
                  .includes(String(item?.PackageContents).toLowerCase()) ||
                String(item?.PackageContents)
                  .toLowerCase()
                  .includes(String(subItem.title).toLowerCase())
            );

            if (partialMatch) {
              console.log(
                `Found partial match for index ${index}:`,
                partialMatch
              );

              // Same logic as exact match
              let selectedHandlingIndex = 0;
              let targetSubItems = [];

              if (this.handlingAllData?.care) {
                const careItems = this.handlingAllData.care;
                const isCareSubItem = careItems.some(
                  (careItem) =>
                    careItem.id === partialMatch.id ||
                    careItem.title === partialMatch.title
                );

                if (isCareSubItem) {
                  selectedHandlingIndex = 1;
                  targetSubItems = this.addNewKey(
                    this.handlingAllData?.care || []
                  );
                } else {
                  targetSubItems = this.addNewKey(
                    this.handlingAllData?.package || []
                  );
                }
              } else {
                targetSubItems = this.addNewKey(
                  this.handlingAllData?.package || []
                );
              }

              // Set the handling method
              if (
                handlingItems &&
                handlingItems.length > selectedHandlingIndex
              ) {
                handlingItems.forEach(
                  (item, i) =>
                    (item.isSelected = i === selectedHandlingIndex ? 1 : 0)
                );

                // Update the form control with the modified array first
                this.dropoffLocations.controls[index]
                  .get('handlingItems')
                  .setValue([...handlingItems]);

                // Then set the selected handling item
                this.dropoffLocations.controls[index]
                  .get('selectedHandlingItem')
                  .setValue(handlingItems[selectedHandlingIndex]);

                console.log(
                  `Updated handlingItems for partial match index ${index}:`,
                  handlingItems
                );
              }

              // Set the appropriate sub-items
              this.dropoffLocations.controls[index]
                .get('handlingSubItems')
                .setValue(targetSubItems);

              // Find and select the matching sub-item
              const matchingIndex = targetSubItems.findIndex(
                (subItem) =>
                  subItem.id === partialMatch.id ||
                  subItem.title === partialMatch.title
              );

              if (matchingIndex !== -1) {
                // Get the current form control value
                const currentSubItems =
                  this.dropoffLocations.controls[index].get(
                    'handlingSubItems'
                  ).value;

                // Use the same pattern as onSelectPackagedItemForBusiness
                currentSubItems.forEach((item: any, index: number) => {
                  item.isSelected = index === matchingIndex ? 1 : 0;
                });

                // Set the selected sub item
                this.dropoffLocations.controls[index]
                  .get('selectedSubItem')
                  .setValue(currentSubItems[matchingIndex]);

                // Update the form control with the modified array
                this.dropoffLocations.controls[index]
                  .get('handlingSubItems')
                  .setValue([...currentSubItems]);

                // Trigger change detection to update the UI
                this.cdr.detectChanges();

                console.log(
                  `Selected partial match sub-item for index ${index}:`,
                  currentSubItems[matchingIndex]
                );
              }
            } else {
              // Look for "Other" or similar fallback
              const otherItem = allSubItems.find(
                (subItem) =>
                  subItem.title.toLowerCase().includes('other') ||
                  subItem.id === 0 ||
                  subItem.title.toLowerCase().includes('miscellaneous')
              );

              if (otherItem) {
                console.log(`Using other item for index ${index}:`, otherItem);

                // Determine which handling method the "Other" item belongs to
                let selectedHandlingIndex = 0;
                let targetSubItems = [];

                if (this.handlingAllData?.care) {
                  const careItems = this.handlingAllData.care;
                  const isCareOtherItem = careItems.some(
                    (careItem) =>
                      careItem.id === otherItem.id ||
                      careItem.title === otherItem.title
                  );

                  if (isCareOtherItem) {
                    selectedHandlingIndex = 1;
                    targetSubItems = this.addNewKey(
                      this.handlingAllData?.care || []
                    );
                  } else {
                    targetSubItems = this.addNewKey(
                      this.handlingAllData?.package || []
                    );
                  }
                } else {
                  targetSubItems = this.addNewKey(
                    this.handlingAllData?.package || []
                  );
                }

                // Set the handling method
                if (
                  handlingItems &&
                  handlingItems.length > selectedHandlingIndex
                ) {
                  handlingItems.forEach(
                    (item, i) =>
                      (item.isSelected = i === selectedHandlingIndex ? 1 : 0)
                  );

                  // Update the form control with the modified array first
                  this.dropoffLocations.controls[index]
                    .get('handlingItems')
                    .setValue([...handlingItems]);

                  // Then set the selected handling item
                  this.dropoffLocations.controls[index]
                    .get('selectedHandlingItem')
                    .setValue(handlingItems[selectedHandlingIndex]);

                  console.log(
                    `Updated handlingItems for other item index ${index}:`,
                    handlingItems
                  );
                }

                // Set the appropriate sub-items
                this.dropoffLocations.controls[index]
                  .get('handlingSubItems')
                  .setValue(targetSubItems);

                // Find and select the "Other" item
                const matchingOtherIndex = targetSubItems.findIndex(
                  (subItem) =>
                    subItem.id === otherItem.id ||
                    subItem.title === otherItem.title
                );

                if (matchingOtherIndex !== -1) {
                  // Get the current form control value
                  const currentSubItems =
                    this.dropoffLocations.controls[index].get(
                      'handlingSubItems'
                    ).value;

                  // Use the same pattern as onSelectPackagedItemForBusiness
                  currentSubItems.forEach((item: any, index: number) => {
                    item.isSelected = index === matchingOtherIndex ? 1 : 0;
                  });

                  // Set the selected sub item
                  this.dropoffLocations.controls[index]
                    .get('selectedSubItem')
                    .setValue(currentSubItems[matchingOtherIndex]);

                  // Update the form control with the modified array
                  this.dropoffLocations.controls[index]
                    .get('handlingSubItems')
                    .setValue([...currentSubItems]);

                  // Store the original content in attachment info
                  this.dropoffLocations.controls[index]
                    .get('attachmentInfo')
                    .setValue(item?.PackageContents);

                  // Trigger change detection to update the UI
                  this.cdr.detectChanges();

                  console.log(
                    `Selected other item for index ${index}:`,
                    currentSubItems[matchingOtherIndex]
                  );
                }
              } else {
                console.warn(
                  `No matching sub-item found for: ${item?.PackageContents}`
                );
              }
            }
          }
        }
      }

      // Import per-dropoff Delivery Plan if provided
      const planRaw =
        item['DeliveryPlan'] ||
        item['Delivery Plan'] ||
        item['deliveryPlan'] ||
        item['delivery plan'];
      if (planRaw) {
        const planStr = String(planRaw).trim().toLowerCase();
        let planKey: 'express' | 'regular' | 'saver' = 'regular';
        if (planStr.startsWith('exp')) planKey = 'express';
        else if (planStr.startsWith('sav')) planKey = 'saver';
        else if (planStr.startsWith('reg')) planKey = 'regular';
        this.dropoffLocations.controls[index]
          .get('deliveryPlan')
          ?.setValue(planKey);
      }

      // Import "Dropoff Details" if present
      const details =
        item['DropoffDetails'] ||
        item['Dropoff Details'] ||
        item['dropoffDetails'] ||
        item['dropoff details'];
      if (details) {
        const detailsStr = String(details).trim();
        this.dropoffLocations.controls[index]
          .get('attachmentInfo')
          ?.setValue(detailsStr);

        // Map to dropoff type selection
        const detailsLower = detailsStr.toLowerCase();
        if (detailsLower.startsWith('door')) {
          this.dropoffLocations.controls[index]
            .get('isDoorToDoorDropoff')
            ?.setValue(true);
        } else if (detailsLower.startsWith('self')) {
          this.dropoffLocations.controls[index]
            .get('isDoorToDoorDropoff')
            ?.setValue(false);
        }
      }

      this.dropoffLocations.markAllAsTouched();

      // Force change detection to update the UI
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error in setImportedDropOffDataForm:', error);
    }
  }

  selectSender(type: 'individual' | 'business') {
    this.senderType = type;

    if (type === 'business') {
      // Initialize business flow
      if (this.form) {
        this.initDropoffLocations();
        // Set to first drop-off location for business flow
        this.selectedIndex = 0;
        // Force change detection to update UI
        this.cdr.detectChanges();
      }
    } else {
      // Clear business dropoffs for individual
      if (this.form && this.dropoffLocations) {
        this.dropoffLocations.clear();
        this.showDropoffDetails = [];
        this.dropoffCount = 1;
        this.selectedIndex = 0;
      }
    }

    // Update Firebase
    this.updateSenderType();
  }
  selectPickup(type: 'door' | 'self') {
    this.pickupType = type;
    this.updatePickupDropoffTypes();

    // Update dropoff model with new pickup type
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }
  selectDropoff(type: 'door' | 'self') {
    this.dropoffType = type;
    this.updatePickupDropoffTypes();

    // Update dropoff model with new dropoff type
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }
  selectPlan(plan: 'express' | 'regular' | 'saver', index?: number) {
    if (
      this.senderType === 'business' &&
      index != null &&
      this.dropoffLocations?.at(index)
    ) {
      this.dropoffLocations.at(index).get('deliveryPlan')?.setValue(plan);
      this.updateBusinessDropoffModel();
      this.syncModelToFirebase();
      return;
    }

    this.deliveryPlan = plan;
    const planMap = {
      express: { id: 1 },
      regular: { id: 2 },
      saver: { id: 3 },
    };
    this.updateDeliveryPlan(planMap[plan]);
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }
  selectHandling(index: number) {
    this.handlingOptions.forEach((item, i) => (item.isSelected = i === index));
  }
  selectPackageItem(index: number) {
    this.packageItems.forEach((item, i) => (item.isSelected = i === index));
  }

  onPickupLocation() {
    this.drawerContext = { type: 'pickup' };
    this.pickupDrawer.open();
    this.isPickupDrawerOpen = true;
  }

  // OPEN DROPOFF LOCATION: for business open AddBulkDropoffDialogComponent, otherwise open drawer
  public onDropOffLocation(groups, groupIndex: number): void {
    if (this.senderType === 'business') {
      // Ensure receiver details exist before opening location dialog
      const group = groups[groupIndex];
      const receiverName = group.get('contactPerson')?.value;
      const receiverPhone = group.get('personNumber')?.value;
      if (!receiverName) {
        this._matSnackBar.open(appMessages.enterReceiverName, 'OKAY', {
          duration: 3000,
        });
        return;
      }
      if (!receiverPhone) {
        this._matSnackBar.open(appMessages.enterContactNumber, 'OKAY', {
          duration: 3000,
        });
        return;
      }

      const dialog = this._matDialog.open(AddBulkDropoffDialogComponent, {
        autoFocus: false,
        width: '610px',
        data: {
          location: group.get('dropoffPoint')?.value || null,
          name: receiverName,
          mobile: receiverPhone,
          isInterRegional: true, // Enable location validation for inter-regional component
        },
      });

      dialog.afterClosed().subscribe((result) => {
        if (result) {
          console.log('[DEBUG] AddBulkDropoffDialog result:', result);
          // Update form controls
          group.get('dropoffPointAddress')?.setValue(result.address);
          group.get('dropoffPoint')?.setValue(result);
          if (group.get('landMark')) {
            group.get('landMark').setValue(result.landmark);
          }

          // Clear destinationNotFound error when a valid location is manually selected
          const addrCtrl = group.get('dropoffPointAddress');
          if (addrCtrl && addrCtrl.hasError('destinationNotFound')) {
            console.log(
              '[DEBUG] Clearing destinationNotFound error for dropoff',
              groupIndex
            );
            const { destinationNotFound, ...rest } = (addrCtrl.errors ||
              {}) as any;
            const newErrors = Object.keys(rest).length ? rest : null;
            addrCtrl.setErrors(newErrors);
            addrCtrl.updateValueAndValidity();
            console.log(
              '[DEBUG] Address control errors after clearing:',
              addrCtrl.errors
            );
          }

          // Mark the form as touched to trigger validation
          group.markAsTouched();
          group.updateValueAndValidity();

          // Update model and sync
          this.updateSpecificDropoffInModel(groupIndex, result);
          this.syncModelToFirebase();

          // Force change detection and re-validate
          this.cdr.detectChanges();

          // Log validation state after update
          console.log(
            '[DEBUG] Validation state after manual location selection:',
            {
              dropoffIndex: groupIndex,
              address: result.address,
              hasDestinationError: addrCtrl?.hasError('destinationNotFound'),
              isValid: group.valid,
              errors: addrCtrl?.errors,
            }
          );
        }
      });
    } else {
      this.drawerContext = { type: 'dropoff', dropoffIndex: groupIndex };
      this.isPickupDrawerOpen = true;
      this.pickupDrawer.open();
    }
  }

  onPickupDrawerClose() {
    this.pickupDrawer.close();
    this.isPickupDrawerOpen = false;
  }

  onPickupLocationSelected(location: any) {
    console.log('pickupLocation', location, this.drawerContext.type);

    if (this.drawerContext.type === 'pickup') {
      this.form.get('pickupLocation').setValue(location.address);
      // store full object for dialog selected highlighting
      this.selectedPickupLocation = location;
      this.initializeInterRegionalOrder(location);
      // Update pickup location in Firebase - ONLY pickup, not dropOff
      this.updatePickupLocation(location);
    } else if (this.drawerContext.type === 'dropoff') {
      console.log('Processing dropoff location selection:', {
        isBusinessPartner: this.isBusinessPartner,
        dropoffIndex: this.drawerContext.dropoffIndex,
        senderType: this.senderType,
        location: location,
        docIdFire: this.docIdFire,
      });

      // Ensure docIdFire is set for business dropoff locations (both business partners and non-business partners)
      if (this.senderType === 'business' && !this.docIdFire) {
        this.initializeInterRegionalOrder(null); // Initialize without pickup location
      }

      if (
        this.senderType === 'business' &&
        this.drawerContext.dropoffIndex !== undefined
      ) {
        // Ensure the dropoff location exists
        if (
          this.dropoffLocations &&
          this.dropoffLocations.at(this.drawerContext.dropoffIndex)
        ) {
          const dropoff = this.dropoffLocations.at(
            this.drawerContext.dropoffIndex
          );

          // Update the form controls
          dropoff.get('dropoffPointAddress').setValue(location.address);
          dropoff.get('dropoffPoint').setValue(location);

          // Also populate contact fields from selected location
          const selectedName = location?.name || location?.contactPerson || '';
          const selectedPhone =
            location?.phone || location?.mobile || location?.personNumber || '';
          if (selectedName && dropoff.get('contactPerson')) {
            dropoff.get('contactPerson').setValue(selectedName);
          }
          if (selectedPhone && dropoff.get('personNumber')) {
            dropoff.get('personNumber').setValue(String(selectedPhone));
          }

          // Mark the form as touched to trigger validation
          dropoff.markAsTouched();

          // Clear destinationNotFound error when a manual selection is made
          const addrCtrl = dropoff.get('dropoffPointAddress');
          if (addrCtrl && addrCtrl.hasError('destinationNotFound')) {
            console.log(
              '[DEBUG] Clearing destinationNotFound error for dropoff',
              this.drawerContext.dropoffIndex,
              'via drawer selection'
            );
            const { destinationNotFound, ...rest } = (addrCtrl.errors ||
              {}) as any;
            const newErrors = Object.keys(rest).length ? rest : null;
            addrCtrl.setErrors(newErrors);
            addrCtrl.updateValueAndValidity();
            console.log(
              '[DEBUG] Address control errors after clearing:',
              addrCtrl.errors
            );
          }

          // Update specific dropoff in model
          this.updateSpecificDropoffInModel(
            this.drawerContext.dropoffIndex,
            location
          );

          // Force change detection to update UI
          this.cdr.detectChanges();

          console.log('[DEBUG] Updated dropoff location via drawer:', {
            dropoffIndex: this.drawerContext.dropoffIndex,
            address: location.address,
            location: location,
            formValue: dropoff.get('dropoffPointAddress').value,
            hasDestinationError: addrCtrl?.hasError('destinationNotFound'),
            isValid: dropoff.valid,
            errors: addrCtrl?.errors,
          });

          // Log validation state after update
          console.log(
            '[DEBUG] Validation state after drawer location selection:',
            {
              canProceed: this.canProceedToNextStep(),
            }
          );

          // Debug dropoff locations after update
          this.debugDropoffLocations();
        } else {
          console.error(
            'Dropoff location not found at index:',
            this.drawerContext.dropoffIndex
          );
        }
      } else if (this.senderType === 'individual') {
        this.form.get('dropoffLocation').setValue(location.address);
        // store full object for dialog selected highlighting (individual dropoff)
        this.selectedDropoffLocation = location;
        // Update individual dropoff model
        this.updateIndividualDropoffModel(location);
      }

      // Sync model to Firebase
      this.syncModelToFirebase();
    }

    this.pickupDrawer.close();
  }

  /**
   * Initialize Inter-Regional Order Doc in Firebase
   */
  initializeInterRegionalOrder(location: any) {
    const time = new Date();
    const userId =
      this.customerData?.id || this._authService?.userValue?.id || Date.now();
    const docId = `${userId}_${time.getTime()}`;

    // Only create initial dropOff if location is provided (for pickup)
    // const dropOff = location ? [
    //   {
    //     packageSize: 2,
    //     sendingItemKey: 4,
    //     location: {
    //       longitude: location?.longitude || 0,
    //       latitude: location?.latitude || 0,
    //       address: location?.address || ''
    //     },
    //     deliveryPlan: 1,
    //     collectCash: 0,
    //     isPhlenuTrustCheckApplied: 0,
    //     id: `${userId}_${time.getTime() + 524}`,
    //     isCoverEnabled: 0,
    //     isDoorToDoorDropoff: 1
    //   }
    // ] : [];

    const docData = {
      regionalId: `${docId}`,
      time: time.toISOString(),
      changeStatus: 0,
      isBusinessInterRegional: this.senderType === 'business' ? 1 : 0,
      country: localStorage.getItem('country') || '',
      createdAt: {
        seconds: Math.floor(time.getTime() / 1000),
        nanoseconds: (time.getTime() % 1000) * 1000000,
      },
      showCsvImportOption: false,
      userId: userId,
      isDoorToDoorPickup: location ? 1 : 0,
      pickup: {
        longitude: location?.longitude || 0,
        latitude: location?.latitude || 0,
        address: location?.address || '',
        name: location?.name || '',
        phone: location?.phone || '',
        phoneCode: location?.phoneCode || '',
      },
      dropOff: [],
      phlenuTrustCheckCommision: 20,
      isPhlenutrustCheckEnabled: 1,

      isCoverEnabled: 0,
      isPhlenuTrustCheckApplied: 0,
      isCashCollectionApplied: 0,
    };

    this.docIdFire = docId;
    console.log(
      'Creating InterRegional order doc with ID:',
      docId,
      'for sender type:',
      this.senderType
    );
    this.afs
      .collection(interRegional)
      .doc(this.docIdFire)
      .set(docData)
      .then(() => {
        console.log('InterRegional order doc created successfully:', docId);
        // Subscribe to document changes after creatio
        this.subscribeDoc();
      })
      .catch((err) => {
        console.error('Error creating InterRegional order doc:', err);
      });
  }

  // Add Firebase update methods following standard order pattern
  updateOrderDoc() {
    if (!this.docIdFire) {
      console.error('docIdFire is not set');
      return null;
    }
    return this.afs
      .collection(interRegional)
      .doc(this.docIdFire)
      .valueChanges();
  }

  // Subscribe to Firebase document changes to get pool data
  subscribeDoc() {
    if (!this.docIdFire) {
      console.error('docIdFire is not set, cannot subscribe');
      return;
    }

    this.isLoadingPaymentData = true; // 🔹 show shimmer while waiting

    const orderDoc$ = this.updateOrderDoc();
    if (orderDoc$) {
      orderDoc$.pipe(takeUntil(this.unsubscribe$)).subscribe(
        (updatedDoc: any) => {
          if (updatedDoc) {
            console.log('InterRegional updatedDoc', updatedDoc);
            this.orderDoc = updatedDoc;

            // Update pool data for payment summary
            this.pool = updatedDoc;
            console.log('Updated this.pool:', this.pool);
            this.isCashCollectionApplied =
              updatedDoc.isCashCollectionApplied == 1;
            // Force change detection to update payment summary
            this.cdr.detectChanges();
          } else {
            console.warn('updatedDoc is null or undefined');
          }

          this.isLoadingPaymentData = false; // 🔹 hide shimmer
        },
        (error) => {
          console.error('Error subscribing to Firebase document:', error);
          this.isLoadingPaymentData = false; // 🔹 also hide on error
        }
      );
    }
  }

  // Optimized Firebase update with batching and debouncing
  updateDocWithParams(params: any, immediate: boolean = false) {
    if (params['changeStatus']) this.isDataLoading = true;

    if (!this.docIdFire) {
      console.error('docIdFire is not set, cannot update Firebase');
      return;
    }

    // For immediate updates (critical data like pickup location), update right away
    if (immediate) {
      this.performFirebaseUpdate(params);
      return;
    }

    // Merge params with pending updates
    this.pendingFirebaseUpdates = { ...this.pendingFirebaseUpdates, ...params };

    // Clear existing timeout
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    // Set new timeout for batched update
    this.updateTimeout = setTimeout(() => {
      this.performBatchedUpdate();
    }, this.UPDATE_DEBOUNCE_MS);
  }

  private performFirebaseUpdate(params: any) {
    if (this.isUpdatingFirebase) {
      console.log('Firebase update already in progress, queuing...');
      return;
    }

    this.isUpdatingFirebase = true;
    const docRef = this.afs.collection(interRegional).doc(this.docIdFire);

    console.log('Performing Firebase update with params:', params);

    docRef
      .update(params)
      .then(() => {
        console.log('Firebase updated successfully');
        this.isUpdatingFirebase = false;
      })
      .catch((err) => {
        console.error('Error updating Firebase:', err);
        this.isUpdatingFirebase = false;
      });
  }

  private performBatchedUpdate() {
    if (Object.keys(this.pendingFirebaseUpdates).length === 0) {
      return;
    }

    const batchedParams = { ...this.pendingFirebaseUpdates };
    this.pendingFirebaseUpdates = {};

    console.log('Performing batched Firebase update:', batchedParams);
    this.performFirebaseUpdate(batchedParams);
  }

  // Force immediate update for critical operations
  forceFirebaseUpdate(params: any) {
    this.performFirebaseUpdate(params);
  }

  // Helper function to conditionally add changeStatus to params
  private addChangeStatusToParams(params: any): any {
    if (this.isReviewOrderClicked) {
      params.changeStatus = 1;
    }
    return params;
  }

  // Update pickup location in Firebase - ONLY pickup field (immediate update for critical data)
  updatePickupLocation(location: any) {
    const params = this.addChangeStatusToParams({
      pickup: {
        longitude: location?.longitude || 0,
        latitude: location?.latitude || 0,
        address: location?.address || '',
        name: location?.name || '',
        phone: location?.phone || '',
        phoneCode: location?.phoneCode || '',
      },
    });
    this.updateDocWithParams(params, true); // Immediate update for critical pickup data
  }

  // Update package details method (kept for backward compatibility)
  updatePackageDetails() {
    // This method is now handled by the model
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }

  // Update handling methods (kept for backward compatibility)
  updateHandlingMethods() {
    // This method is now handled by the model
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }

  // Update cash collection (kept for backward compatibility)
  updateCashCollection() {
    // Update main order level cash collection
    const params = this.addChangeStatusToParams({
      isCashCollectionApplied: this.cashCollection ? 1 : 0,
    });
    this.updateDocWithParams(params);

    // This method is now handled by the model
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }

  // Update trust check (kept for backward compatibility)
  updateTrustCheck() {
    // Update main order level trust check
    const params = this.addChangeStatusToParams({
      isPhlenuTrustCheckApplied: this.trustCheck ? 1 : 0,
    });
    this.updateDocWithParams(params);

    // This method is now handled by the model
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }

  // Update delivery plan (kept for backward compatibility)
  updateDeliveryPlan(plan: any) {
    // This method is now handled by the model
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }

  // Update security cover (kept for backward compatibility)
  updateSecurityCover() {
    // Update main order level security cover
    const params = this.addChangeStatusToParams({
      isCoverEnabled: this.securityCover ? 1 : 0,
    });
    this.updateDocWithParams(params);

    // This method is now handled by the model
    if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel();
    } else {
      this.updateBusinessDropoffModel();
    }
    this.syncModelToFirebase();
  }

  // Update pickup and dropoff types in Firebase - ONLY isDoorToDoorPickup and isDoorToDoorDropoff fields
  updatePickupDropoffTypes() {
    const params = this.addChangeStatusToParams({
      isDoorToDoorPickup: this.pickupType === 'door' ? 1 : 0,
    });

    // Add dropoff type update for individual sender
    if (this.senderType === 'individual') {
      params['dropOff.0.isDoorToDoorDropoff'] =
        this.dropoffType === 'door' ? 1 : 0;
    }
    // Note: For business sender, each dropoff location manages its own isDoorToDoorDropoff
    // Use updateBusinessDropoffType() method for individual location updates

    this.updateDocWithParams(params);
  }

  // Update specific business dropoff location type
  updateBusinessDropoffType(dropoffIndex: number, isDoorToDoor: boolean) {
    if (this.senderType !== 'business') return;

    // Update the form control
    const control = this.dropoffLocations.controls[dropoffIndex];
    if (control) {
      control.get('isDoorToDoorDropoff')?.setValue(isDoorToDoor);
    }

    // The syncModelToFirebase() call will handle the complete dropoff array update
  }

  // Update sender type in Firebase - ONLY isBusinessInterRegional field
  updateSenderType() {
    const params = this.addChangeStatusToParams({
      isBusinessInterRegional: this.senderType === 'business' ? 1 : 0,
    });
    this.updateDocWithParams(params);
  }

  // Original nextStep method for business logic with validation
  nextStep() {
    // Validate current step before proceeding (with error messages)
    if (!this.validateCurrentStepWithMessages()) {
      return;
    }

    if (this.stepIndex === 0 && this.senderType === 'business') {
      // this.initDropoffLocations();
      // Ensure we start at the first drop-off location
      this.selectedIndex = 0;
    }
    if (this.stepIndex < 2) {
      this.stepIndex++;
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // If moving to review step (step 2), enable changeStatus updates and refresh payment summary data
      if (this.stepIndex === 2) {
        console.log(
          'Moving to review step, enabling changeStatus updates and refreshing payment summary data...'
        );
        this.isReviewOrderClicked = true;
        this.refreshPaymentSummaryData();
        // Trigger a sync to update changeStatus now that we're in review mode
        this.syncModelToFirebase();
      }
    }
  }

  // Validation method to check if current step is valid with error messages
  validateCurrentStepWithMessages(): boolean {
    switch (this.stepIndex) {
      case 0:
        return this.validateStep0WithMessages();
      case 1:
        return this.validateStep1WithMessages();
      default:
        return true;
    }
  }

  // Step 1 validation with error messages
  validateStep1WithMessages(): boolean {
    if (this.senderType === 'individual') {
      return this.validateIndividualStep1WithMessages();
    } else if (this.senderType === 'business') {
      return this.validateBusinessStep1WithMessages();
    }
    return true;
  }

  // Validation method to check if current step is valid
  validateCurrentStep(): boolean {
    console.log('[VALIDATION] validateCurrentStep called', {
      stepIndex: this.stepIndex,
      senderType: this.senderType,
    });

    let result = false;
    switch (this.stepIndex) {
      case 0:
        result = this.validateStep0();
        break;
      case 1:
        result = this.validateStep1();
        break;
      default:
        result = true;
    }

    console.log('[VALIDATION] validateCurrentStep result:', result);
    return result;
  }

  // Step 0 validation (pure validation without side effects)
  validateStep0(): boolean {
    // Check if sender type is selected
    if (!this.senderType) {
      return false;
    }

    // Check if pickup type is selected
    if (!this.pickupType) {
      return false;
    }

    // Check if pickup location is filled
    if (!this.form.get('pickupLocation')?.value) {
      return false;
    }

    // For individual sender, check dropoff details
    if (this.senderType === 'individual') {
      if (!this.dropoffType) {
        return false;
      }

      if (!this.form.get('dropoffLocation')?.value) {
        return false;
      }
    }

    // For business sender, check dropoff count
    if (this.senderType === 'business') {
      if (this.dropoffCount < 2) {
        return false;
      }
    }

    return true;
  }

  // Step 0 validation with error messages (called only when user clicks next)
  validateStep0WithMessages(): boolean {
    // Check if sender type is selected
    if (!this.senderType) {
      this._matSnackBar.open(
        'Please select sender type (Individual or Business)',
        'OK',
        { duration: 3000 }
      );
      return false;
    }

    // Check if pickup type is selected
    if (!this.pickupType) {
      this._matSnackBar.open(
        'Please select pickup type (Door Pickup or Self Dropoff)',
        'OK',
        { duration: 3000 }
      );
      return false;
    }

    // Check if pickup location is filled
    if (!this.form.get('pickupLocation')?.value) {
      this._matSnackBar.open('Please select pickup location', 'OK', {
        duration: 3000,
      });
      return false;
    }

    // For individual sender, check dropoff details
    if (this.senderType === 'individual') {
      if (!this.dropoffType) {
        this._matSnackBar.open(
          'Please select dropoff type (Door Dropoff or Self Pickup)',
          'OK',
          { duration: 3000 }
        );
        return false;
      }

      if (!this.form.get('dropoffLocation')?.value) {
        this._matSnackBar.open('Please select dropoff location', 'OK', {
          duration: 3000,
        });
        return false;
      }
    }

    // For business sender, check dropoff count
    if (this.senderType === 'business') {
      if (this.dropoffCount < 2) {
        this._matSnackBar.open(
          'Please set at least 2 dropoff locations for business orders',
          'OK',
          { duration: 3000 }
        );
        return false;
      }
    }

    return true;
  }

  // Step 1 validation
  validateStep1(): boolean {
    if (this.senderType === 'individual') {
      return this.validateIndividualStep1();
    } else if (this.senderType === 'business') {
      return this.validateBusinessStep1();
    }
    return true;
  }

  // Individual sender Step 1 validation (pure validation without side effects)
  validateIndividualStep1(): boolean {
    // Check delivery plan
    if (!this.deliveryPlan) {
      return false;
    }

    // Check package size
    const selectedPackageSize = this.packsizes.find(
      (item) => item.isSelected === 1
    );
    if (!selectedPackageSize) {
      return false;
    }

    // Check handling method
    const selectedHandlingMethod = this.handlingMethods.find(
      (item) => item.isSelected === 1
    );
    if (!selectedHandlingMethod) {
      return false;
    }

    // Check package item
    const selectedPackageItem = this.handlingData?.find(
      (item) => item.isSelected === 1
    );
    if (!selectedPackageItem) {
      return false;
    }

    return true;
  }

  // Individual sender Step 1 validation with error messages
  validateIndividualStep1WithMessages(): boolean {
    // Check delivery plan
    if (!this.deliveryPlan) {
      this._matSnackBar.open(
        'Please select a delivery plan (Express, Regular, or Saver)',
        'OK',
        { duration: 3000 }
      );
      return false;
    }

    // Check package size
    const selectedPackageSize = this.packsizes.find(
      (item) => item.isSelected === 1
    );
    if (!selectedPackageSize) {
      this._matSnackBar.open('Please select package size', 'OK', {
        duration: 3000,
      });
      return false;
    }

    // Check handling method
    const selectedHandlingMethod = this.handlingMethods.find(
      (item) => item.isSelected === 1
    );
    if (!selectedHandlingMethod) {
      this._matSnackBar.open('Please select what we are handling', 'OK', {
        duration: 3000,
      });
      return false;
    }

    // Check package item
    const selectedPackageItem = this.handlingData?.find(
      (item) => item.isSelected === 1
    );
    if (!selectedPackageItem) {
      this._matSnackBar.open('Please select package item', 'OK', {
        duration: 3000,
      });
      return false;
    }

    return true;
  }

  // Business sender Step 1 validation (pure validation without side effects)
  validateBusinessStep1(): boolean {
    console.log('[VALIDATION] validateBusinessStep1 called');

    // Check delivery plan (allow per-dropoff or global)
    const hasGlobalPlan = !!this.deliveryPlan;
    let allHavePlan = true;
    if (this.dropoffLocations && this.dropoffLocations.controls?.length) {
      allHavePlan = this.dropoffLocations.controls.every((g) => {
        const plan = g.get('deliveryPlan')?.value;
        return !!(plan || this.deliveryPlan);
      });
    }
    if (!hasGlobalPlan && !allHavePlan) {
      console.log('[VALIDATION] Failed: Delivery plan not selected');
      return false;
    }

    // Check if there are dropoff locations
    if (!this.dropoffLocations || this.dropoffLocations.length < 2) {
      console.log('[VALIDATION] Failed: Less than 2 dropoff locations', {
        dropoffCount: this.dropoffLocations?.length || 0,
      });
      return false;
    }

    // Validate each dropoff location
    for (let i = 0; i < this.dropoffLocations.controls.length; i++) {
      const dropoff = this.dropoffLocations.controls[i];
      console.log(`[VALIDATION] Validating dropoff ${i + 1}`);

      // Check contact person
      const contactPerson = dropoff.get('contactPerson')?.value;
      const contactPersonInvalid = dropoff.get('contactPerson')?.invalid;
      if (!contactPerson || contactPersonInvalid) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Contact person invalid`,
          {
            value: contactPerson,
            invalid: contactPersonInvalid,
          }
        );
        return false;
      }

      // Check person number
      const personNumber = dropoff.get('personNumber')?.value;
      const personNumberInvalid = dropoff.get('personNumber')?.invalid;
      if (!personNumber || personNumberInvalid) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Person number invalid`,
          {
            value: personNumber,
            invalid: personNumberInvalid,
          }
        );
        return false;
      }

      // Check dropoff location
      const dropoffAddress = dropoff.get('dropoffPointAddress')?.value;
      if (!dropoffAddress) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Dropoff address missing`
        );
        return false;
      }

      // Block if destination validation failed
      const addrCtrl = dropoff.get('dropoffPointAddress');
      const hasDestinationError = addrCtrl?.hasError('destinationNotFound');
      if (hasDestinationError) {
        console.log(
          `[VALIDATION] Failed at dropoff ${
            i + 1
          }: Destination not found error`,
          {
            address: dropoffAddress,
            errors: addrCtrl?.errors,
          }
        );
        return false;
      }

      // Check package size
      const packageSizes = dropoff.get('packageSizes')?.value || [];
      const selectedPackageSize = packageSizes.find(
        (size: any) => size.isSelected === 1
      );
      if (!selectedPackageSize) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Package size not selected`
        );
        return false;
      }

      // Check handling method
      const handlingItems = dropoff.get('handlingItems')?.value || [];
      const selectedHandlingItem = handlingItems.find(
        (item: any) => item.isSelected === 1
      );
      if (!selectedHandlingItem) {
        console.log(
          `[VALIDATION] Failed at dropoff ${
            i + 1
          }: Handling method not selected`
        );
        return false;
      }

      // Check package item
      const handlingSubItems = dropoff.get('handlingSubItems')?.value || [];
      const selectedSubItem = handlingSubItems.find(
        (item: any) => item.isSelected === 1
      );
      if (!selectedSubItem) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Package item not selected`
        );
        return false;
      }

      console.log(`[VALIDATION] Dropoff ${i + 1} is valid`);
    }

    console.log('[VALIDATION] All dropoff locations are valid');
    return true;
  }

  // Business sender Step 1 validation with error messages
  validateBusinessStep1WithMessages(): boolean {
    console.log('[VALIDATION] validateBusinessStep1WithMessages called');

    // Check delivery plan (allow per-dropoff or global)
    const hasGlobalPlan = !!this.deliveryPlan;
    let allHavePlan = true;
    if (this.dropoffLocations && this.dropoffLocations.controls?.length) {
      allHavePlan = this.dropoffLocations.controls.every((g) => {
        const plan = g.get('deliveryPlan')?.value;
        return !!(plan || this.deliveryPlan);
      });
    }
    if (!hasGlobalPlan && !allHavePlan) {
      console.log('[VALIDATION] Failed: Delivery plan not selected');
      this._matSnackBar.open(
        'Please select a delivery plan (Express, Regular, or Saver)',
        'OK',
        { duration: 3000 }
      );
      return false;
    }

    // Check if there are dropoff locations
    if (!this.dropoffLocations || this.dropoffLocations.length < 2) {
      console.log('[VALIDATION] Failed: Less than 2 dropoff locations', {
        dropoffCount: this.dropoffLocations?.length || 0,
      });
      this._matSnackBar.open('Please add at least 2 dropoff locations', 'OK', {
        duration: 3000,
      });
      return false;
    }

    // Validate each dropoff location
    let invalidDropoffIndex = -1;
    let invalidField = '';

    for (let i = 0; i < this.dropoffLocations.controls.length; i++) {
      const dropoff = this.dropoffLocations.controls[i];
      console.log(`[VALIDATION] Validating dropoff ${i + 1} with messages`);

      // Check contact person
      const contactPerson = dropoff.get('contactPerson')?.value;
      const contactPersonInvalid = dropoff.get('contactPerson')?.invalid;
      if (!contactPerson || contactPersonInvalid) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Contact person invalid`,
          {
            value: contactPerson,
            invalid: contactPersonInvalid,
          }
        );
        invalidDropoffIndex = i;
        invalidField = 'contact person name';
        break;
      }

      // Check person number
      const personNumber = dropoff.get('personNumber')?.value;
      const personNumberInvalid = dropoff.get('personNumber')?.invalid;
      if (!personNumber || personNumberInvalid) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Person number invalid`,
          {
            value: personNumber,
            invalid: personNumberInvalid,
          }
        );
        invalidDropoffIndex = i;
        invalidField = 'contact number';
        break;
      }

      // Check dropoff location
      const dropoffAddress = dropoff.get('dropoffPointAddress')?.value;
      if (!dropoffAddress) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Dropoff address missing`
        );
        invalidDropoffIndex = i;
        invalidField = 'dropoff location';
        break;
      }

      // Check destination validation error
      const addrCtrl = dropoff.get('dropoffPointAddress');
      const hasDestinationError = addrCtrl?.hasError('destinationNotFound');
      if (hasDestinationError) {
        console.log(
          `[VALIDATION] Failed at dropoff ${
            i + 1
          }: Destination not found error`,
          {
            address: dropoffAddress,
            errors: addrCtrl?.errors,
          }
        );
        invalidDropoffIndex = i;
        invalidField = 'supported destination (choose a valid destination)';
        break;
      }

      // Check package size
      const packageSizes = dropoff.get('packageSizes')?.value || [];
      const selectedPackageSize = packageSizes.find(
        (size: any) => size.isSelected === 1
      );
      if (!selectedPackageSize) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Package size not selected`
        );
        invalidDropoffIndex = i;
        invalidField = 'package size';
        break;
      }

      // Check handling method
      const handlingItems = dropoff.get('handlingItems')?.value || [];
      const selectedHandlingItem = handlingItems.find(
        (item: any) => item.isSelected === 1
      );
      if (!selectedHandlingItem) {
        console.log(
          `[VALIDATION] Failed at dropoff ${
            i + 1
          }: Handling method not selected`
        );
        invalidDropoffIndex = i;
        invalidField = 'handling method';
        break;
      }

      // Check package item
      const handlingSubItems = dropoff.get('handlingSubItems')?.value || [];
      const selectedSubItem = handlingSubItems.find(
        (item: any) => item.isSelected === 1
      );
      if (!selectedSubItem) {
        console.log(
          `[VALIDATION] Failed at dropoff ${i + 1}: Package item not selected`
        );
        invalidDropoffIndex = i;
        invalidField = 'package item';
        break;
      }

      console.log(`[VALIDATION] Dropoff ${i + 1} is valid`);
    }

    if (invalidDropoffIndex >= 0) {
      console.log('[VALIDATION] Validation failed:', {
        invalidDropoffIndex,
        invalidField,
      });
      this._matSnackBar.open(
        `Please complete ${invalidField} for dropoff location ${
          invalidDropoffIndex + 1
        }`,
        'OK',
        { duration: 3000 }
      );

      // Switch to the invalid tab
      this.selectedIndex = invalidDropoffIndex;
      this.cdr.detectChanges();

      return false;
    }

    console.log('[VALIDATION] All dropoff locations are valid (with messages)');
    return true;
  }

  // Helper method to check if next step is available
  canProceedToNextStep(): boolean {
    const result = this.validateCurrentStep();
    console.log('[VALIDATION] canProceedToNextStep result:', result, {
      stepIndex: this.stepIndex,
      senderType: this.senderType,
      dropoffCount: this.dropoffLocations?.length || 0,
    });
    return result;
  }

  // Get user-friendly validation error message for tooltip
  getValidationErrorMessage(): string {
    if (this.stepIndex === 0) {
      // Step 0 validation messages
      if (!this.senderType) {
        return 'Please select sender type (Individual or Business)';
      }
      if (!this.pickupType) {
        return 'Please select pickup type (Door Pickup or Self Dropoff)';
      }
      if (!this.form.get('pickupLocation')?.value) {
        return 'Please select pickup location';
      }
      if (this.senderType === 'individual') {
        if (!this.dropoffType) {
          return 'Please select dropoff type (Door Dropoff or Self Pickup)';
        }
        if (!this.form.get('dropoffLocation')?.value) {
          return 'Please select dropoff location';
        }
      }
      if (this.senderType === 'business') {
        if (this.dropoffCount < 2) {
          return 'Please add at least 2 dropoff locations for business orders';
        }
      }
    } else if (this.stepIndex === 1) {
      // Step 1 validation messages
      if (this.senderType === 'individual') {
        if (!this.deliveryPlan) {
          return 'Please select a delivery plan (Express, Regular, or Saver)';
        }
        const selectedPackageSize = this.packsizes.find(
          (item) => item.isSelected === 1
        );
        if (!selectedPackageSize) {
          return 'Please select package size';
        }
        const selectedHandlingMethod = this.handlingMethods.find(
          (item) => item.isSelected === 1
        );
        if (!selectedHandlingMethod) {
          return 'Please select what we are handling';
        }
        const selectedPackageItem = this.handlingData?.find(
          (item) => item.isSelected === 1
        );
        if (!selectedPackageItem) {
          return 'Please select package item';
        }
      } else if (this.senderType === 'business') {
        // Check delivery plan
        const hasGlobalPlan = !!this.deliveryPlan;
        let allHavePlan = true;
        if (this.dropoffLocations && this.dropoffLocations.controls?.length) {
          allHavePlan = this.dropoffLocations.controls.every((g) => {
            const plan = g.get('deliveryPlan')?.value;
            return !!(plan || this.deliveryPlan);
          });
        }
        if (!hasGlobalPlan && !allHavePlan) {
          return 'Please select a delivery plan (Express, Regular, or Saver)';
        }

        // Check if there are dropoff locations
        if (!this.dropoffLocations || this.dropoffLocations.length < 2) {
          return 'Please add at least 2 dropoff locations';
        }

        // Validate each dropoff location
        for (let i = 0; i < this.dropoffLocations.controls.length; i++) {
          const dropoff = this.dropoffLocations.controls[i];

          // Check contact person
          if (
            !dropoff.get('contactPerson')?.value ||
            dropoff.get('contactPerson')?.invalid
          ) {
            return `Dropoff ${i + 1}: Please enter contact person name`;
          }

          // Check person number
          if (
            !dropoff.get('personNumber')?.value ||
            dropoff.get('personNumber')?.invalid
          ) {
            return `Dropoff ${i + 1}: Please enter contact number`;
          }

          // Check dropoff location
          if (!dropoff.get('dropoffPointAddress')?.value) {
            return `Dropoff ${i + 1}: Please select dropoff location`;
          }
          
          // Check destination validation error
          if (dropoff.get('dropoffPointAddress')?.hasError('destinationNotFound')) {
            return `Dropoff ${i + 1}: Please select a valid destination (current address is not supported)`;
          }

          // Check package size
          const packageSizes = dropoff.get('packageSizes')?.value || [];
          const selectedPackageSize = packageSizes.find(
            (size: any) => size.isSelected === 1
          );
          if (!selectedPackageSize) {
            return `Dropoff ${i + 1}: Please select package size`;
          }

          // Check handling method
          const handlingItems = dropoff.get('handlingItems')?.value || [];
          const selectedHandlingItem = handlingItems.find(
            (item: any) => item.isSelected === 1
          );
          if (!selectedHandlingItem) {
            return `Dropoff ${i + 1}: Please select handling method`;
          }

          // Check package item
          const handlingSubItems = dropoff.get('handlingSubItems')?.value || [];
          const selectedSubItem = handlingSubItems.find(
            (item: any) => item.isSelected === 1
          );
          if (!selectedSubItem) {
            return `Dropoff ${i + 1}: Please select package item`;
          }
        }
      }
    }
    return '';
  }

  // Helper method to check if current business dropoff location is valid
  isCurrentBusinessDropoffValid(): boolean {
    if (this.senderType !== 'business' || !this.dropoffLocations) {
      return true;
    }

    const currentDropoff = this.dropoffLocations.controls[this.selectedIndex];
    if (!currentDropoff) {
      return false;
    }

    // Check required fields for current dropoff
    const contactPerson = currentDropoff.get('contactPerson')?.value;
    const personNumber = currentDropoff.get('personNumber')?.value;
    const dropoffAddress = currentDropoff.get('dropoffPointAddress')?.value;

    // Basic validation - all required fields should be filled
    return !!(contactPerson && personNumber && dropoffAddress);
  }

  prevStep() {
    if (this.stepIndex > 0) {
      this.stepIndex--;
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // If going back from review step, ensure we sync any pending changes
      if (this.stepIndex === 1) {
        console.log(
          'Going back from review step, syncing any pending changes...'
        );
        this.syncModelToFirebase();
      }
    }
  }

  onSelectPackage(i: number) {
    // For individual sender type - update the global packsizes array
    if (this.senderType === 'individual') {
      this.packsizes.forEach((item, index) => {
        if (i === index) {
          item.isSelected = 1;
        } else {
          item.isSelected = 0;
        }
      });

      // Update the form with selected package size
      const selectedPackageSize = this.packsizes.find(
        (item) => item.isSelected
      );
      this.form.get('orderPackageSize')?.setValue(selectedPackageSize);
      this.selectedPackageSize = selectedPackageSize;

      // Update the dropoff model
      this.updateIndividualDropoffModel();
      this.syncModelToFirebase();

      // Save to localStorage immediately
      this.saveDataInfoLocal();
    }
    // For business sender type - update the specific dropoff location's package sizes
    else if (this.senderType === 'business') {
      const currentDropoffIndex = this.selectedIndex;
      if (this.dropoffLocations.controls[currentDropoffIndex]) {
        const packageSizes =
          this.dropoffLocations.controls[currentDropoffIndex].get(
            'packageSizes'
          ).value;

        packageSizes.forEach((item: any, index: number) => {
          if (i === index) {
            item.isSelected = 1;
          } else {
            item.isSelected = 0;
          }
        });

        // Update the selected package size in the form
        const selectedPackageSize = packageSizes.find(
          (item: any) => item.isSelected
        );
        this.dropoffLocations.controls[currentDropoffIndex]
          .get('packageSize')
          .setValue(selectedPackageSize);

        // Update the dropoff model
        this.updateBusinessDropoffModel();
        this.syncModelToFirebase();

        // Save to localStorage immediately
        this.saveDataInfoLocal();
      }
    }
  }

  // Add these methods after the existing methods

  /**
   * Fetch handling data from API (similar to standard order)
   */
  getOrderHandlingType() {
    return new Promise((resolve, reject) => {
      this._authService.getOrderHandlingType().subscribe((res: any) => {
        if (res.response == 200) {
          this.handlingAllData = res.data;
          resolve(true);
        } else {
          this._matSnackBar.open(res.message, 'Okay', { duration: 3000 });
          reject(res.message);
        }
      });
    });
  }

  getCoverFeeValue() {
    return new Promise((resolve, reject) => {
      const userId = this.userID;
      if (!userId) {
        reject('User ID not found');
        return;
      }

      this._authService.getCoverFeePercent(userId).subscribe((res: any) => {
        if (res.response == 200) {
          console.log('Fetched cover fee percent:', res.data);
          this.coverFeePercent = res.data.coverFeePercent;
          resolve(true);
        } else {
          // this._matSnackBar.open(res.message, 'Okay', { duration: 3000 });
          reject(res.message);
        }
      });
    });
  }

  /**
   * Add isSelected property to array items and include "Other" option
   */
  addNewKey(array) {
    if (!array) return [];

    // Check if "Other" item already exists (id === 0)
    const hasOtherItem = array.some((item) => item.id === 0);

    let updatedArray = [...array];

    // Add "Other" option only if it doesn't already exist
    if (!hasOtherItem) {
      const otherItem = {
        id: 0,
        title: 'Other',
        images: 'assets/images/icons/other.png',
        isSelected: 0,
      };
      updatedArray.push(otherItem);
    }

    // Only set isSelected to 0 if it doesn't already exist
    updatedArray.forEach((obj) => {
      if (obj['isSelected'] === undefined) {
        obj['isSelected'] = 0;
      }
    });

    return updatedArray;
  }

  /**
   * Generic selection logic for arrays
   */
  selectLogic(arr, selectedIndex) {
    arr.forEach((element, index): any => {
      if (selectedIndex == index) {
        return (element.isSelected = 1);
      } else {
        element.isSelected = 0;
      }
    });
  }

  // Update the selectHandlingMethods method
  selectHandlingMethods(i: number) {
    // For individual sender type
    if (this.senderType === 'individual') {
      this.selectLogic(this.handlingMethods, i);

      const selectedHandling = this.handlingMethods.find(
        (item) => item.isSelected
      );
      this.form.get('selectedHandlingMethod')?.setValue(selectedHandling);

      // Update handling data based on selection
      if (selectedHandling?.id === 1) {
        // Packaged items
        this.handlingData = this.addNewKey(this.handlingAllData?.package || []);
      } else if (selectedHandling?.id === 2) {
        // Handle with care items
        this.handlingData = this.addNewKey(this.handlingAllData?.care || []);
      }

      // Update the dropoff model
      this.updateIndividualDropoffModel();
      this.syncModelToFirebase();

      // Save to localStorage immediately
      this.saveDataInfoLocal();
    }
    // For business sender type
    else if (this.senderType === 'business') {
      const currentDropoffIndex = this.selectedIndex;
      if (this.dropoffLocations.controls[currentDropoffIndex]) {
        const handlingItems =
          this.dropoffLocations.controls[currentDropoffIndex].get(
            'handlingItems'
          ).value;

        this.selectLogic(handlingItems, i);

        const selectedHandling = handlingItems.find(
          (item: any) => item.isSelected
        );
        this.dropoffLocations.controls[currentDropoffIndex]
          .get('selectedHandlingItem')
          .setValue(selectedHandling);

        // Update handling sub-items based on selection
        if (selectedHandling?.id === 1) {
          this.dropoffLocations.controls[currentDropoffIndex]
            .get('handlingSubItems')
            .setValue(this.addNewKey(this.handlingAllData?.package || []));
        } else if (selectedHandling?.id === 2) {
          this.dropoffLocations.controls[currentDropoffIndex]
            .get('handlingSubItems')
            .setValue(this.addNewKey(this.handlingAllData?.care || []));
        }

        // Update the dropoff model
        this.updateBusinessDropoffModel();
        this.syncModelToFirebase();

        // Save to localStorage immediately
        this.saveDataInfoLocal();
      }
    }
  }

  // Update the onSelectPackagedItem method
  onSelectPackagedItem(i: number) {
    // For individual sender type
    if (this.senderType === 'individual') {
      this.selectLogic(this.handlingData, i);

      const selectedItem = this.handlingData.find((item) => item.isSelected);
      this.form.get('selectedHandlingItem')?.setValue(selectedItem);

      // If "Other" is selected (id === 0), clear the attachmentInfo field
      if (selectedItem?.id === 0) {
        this.form.get('attachmentInfo')?.setValue('');
      }

      // Update the dropoff model
      this.updateIndividualDropoffModel();
      this.syncModelToFirebase();

      // Save to localStorage immediately
      this.saveDataInfoLocal();
    }
    // For business sender type
    else if (this.senderType === 'business') {
      const currentDropoffIndex = this.selectedIndex;
      if (this.dropoffLocations.controls[currentDropoffIndex]) {
        const handlingSubItems =
          this.dropoffLocations.controls[currentDropoffIndex].get(
            'handlingSubItems'
          ).value;

        this.selectLogic(handlingSubItems, i);

        const selectedItem = handlingSubItems.find(
          (item: any) => item.isSelected
        );
        this.dropoffLocations.controls[currentDropoffIndex]
          .get('selectedSubItem')
          .setValue(selectedItem);

        // If "Other" is selected (id === 0), clear the attachmentInfo for this dropoff
        if (selectedItem?.id === 0) {
          // Clear the attachmentInfo field for this dropoff (it should already exist from addDropRow)
          this.dropoffLocations.controls[currentDropoffIndex]
            .get('attachmentInfo')
            ?.setValue('');
        }

        // Update the dropoff model
        this.updateBusinessDropoffModel();
        this.syncModelToFirebase();

        // Save to localStorage immediately
        this.saveDataInfoLocal();
      }
    }
  }

  // Add method to initialize handling data (call this in ngOnInit or when needed)
  async initializeHandlingData() {
    try {
      await this.getOrderHandlingType();
      console.log('Handling data initialized:', this.handlingAllData);

      // Initialize default handling method and data for individual sender
      if (this.senderType === 'individual') {
        // Set first handling method as selected by default
        // this.handlingMethods[0].isSelected = 1;
        // this.form.get('selectedHandlingMethod')?.setValue(this.handlingMethods[0]);
        // Don't initialize handlingData with default since no handling method is selected
        // this.handlingData = this.addNewKey(this.handlingAllData?.package || []);
        // console.log('Default handling data loaded:', this.handlingData);
      }

      // Initialize default handling sub-items for business dropoff locations
      if (
        this.senderType === 'business' &&
        this.dropoffLocations &&
        this.dropoffLocations.controls.length > 0
      ) {
        this.dropoffLocations.controls.forEach((control, index) => {
          // Set first handling method as selected by default
          const handlingItems = control.get('handlingItems')?.value;
          if (handlingItems && handlingItems.length > 0) {
            // Don't set any item as selected by default
            // handlingItems[0].isSelected = 1;
            // control.get('selectedHandlingItem')?.setValue(handlingItems[0]);
            // Don't initialize handlingSubItems with default since no handling method is selected
            // const defaultSubItems = this.addNewKey(this.handlingAllData?.package || []);
            // control.get('handlingSubItems')?.setValue(defaultSubItems);
            // console.log(`Default handling sub-items loaded for dropoff ${index}:`, defaultSubItems);
          }
        });
      }
    } catch (error) {
      console.error('Error initializing handling data:', error);
    }
  }

  // Add this method for toggling dropoff details
  toggleDropoffDetails(index: number) {
    this.showDropoffDetails[index] = !this.showDropoffDetails[index];
  }

  onSelectPaymentMethod(selectedItem, selectedIndex) {
    this.paymentMethods.forEach((item) => (item.isSelected = 0));

    // Validation checks
    if (!this.form.get('pickupLocation').value) {
      this._matSnackBar.open('Please select pickup location', 'OKAY', {
        duration: 3000,
      });
      return;
    } else if (
      this.senderType === 'individual' &&
      !this.form.get('dropoffLocation').value
    ) {
      this._matSnackBar.open('Please select dropoff location', 'OKAY', {
        duration: 3000,
      });
      return;
    } else if (
      this.senderType === 'business' &&
      this.dropoffLocations.controls.length === 0
    ) {
      this._matSnackBar.open(
        'Please add at least one dropoff location',
        'OKAY',
        { duration: 3000 }
      );
      return;
    } else if (
      !(
        !!this.deliveryPlan ||
        (this.senderType === 'business' &&
          this.dropoffLocations &&
          this.dropoffLocations.controls?.every(
            (g) => !!g.get('deliveryPlan')?.value
          ))
      )
    ) {
      this._matSnackBar.open('Please select delivery plan', 'OKAY', {
        duration: 3000,
      });
      return;
    } else if (
      this.selectedDeliveryMethod?.pdasWalletAmount == 0 &&
      selectedIndex == 2
    ) {
      this._matSnackBar.open('Insufficient wallet balance', 'OKAY', {
        duration: 3000,
      });
      return;
    } else {
      selectedItem.isSelected = 1;
      this.selectedPaymentMethod = selectedItem;
      this.updatePaymentMethod(selectedItem);

      console.log('this.selectedPaymentMethod', this.selectedPaymentMethod);

      // Mirror Standard Order behavior: flag wallet application on selection
      const params = this.addChangeStatusToParams({
        isPdasWalletApplied: this.selectedPaymentMethod?.id == 4 ? 1 : 0,
      });
      this.updateDocWithParams(params);
    }
  }

  // Add method to initialize Firebase data
  initializeFirebaseData() {
    // This method should be called when you receive data from Firebase
    // For now, we'll set default values
    this.orderDetail = {
      orderStatus: 0,
      isPhlenuTrustCheckApplied: 0,
      isCashCollectionApplied: 0,
      createdDate: new Date(),
      order_number: '',
      expectedDeliveryTime: '',
      pickUpName: '',
      pickUpPhone: '',
      pickUpAddress: '',
      basePrice: 0,
      dropoffFee: 0,
      pickupFee: 0,
      phlenuTrustCheckCommision: 0,
      isCoverApplied: false,
      totalCoverFee: 0,
      paymentDirection: 0,
      totalCharges: 0,
      cashCollected: 0,
      isSubtractPriceFromDeliveryFee: 0,
      isSubtractPriceFromPickUpFee: 0,
      settlementAmount: 0,
    };

    this.dropDetail = [];

    // Initialize derived properties
    this.updateDerivedProperties();
  }

  // Initialize dropoff model
  initializeDropoffModel() {
    this.dropoffModel = [];
  }

  // Create a new dropoff entry in the model
  createDropoffModel(index: number = 0): DropoffModel {
    return {
      packageSize: 2,
      sendingItemKey: 4,
      location: {
        longitude: 0,
        latitude: 0,
        address: '',
        destinationAddress: '',
      },
      deliveryPlan:
        this.deliveryPlan === 'express'
          ? 1
          : this.deliveryPlan === 'regular'
          ? 2
          : 3,
      collectCash: 0,
      isPhlenuTrustCheckApplied: 0,
      id: Date.now().toString() + String(index),
      isCoverEnabled: 0,
      isDoorToDoorDropoff: this.dropoffType === 'door' ? 1 : 0,
      // Initialize new fields
      name: '',
      phone: '',
      phoneCode: this.selectedCountryCode || '',
      sendingItemName: '',
    };
  }

  // Update dropoff model for individual sender
  updateIndividualDropoffModel(location?: any) {
    if (this.senderType === 'individual') {
      console.log('Updating individual dropoff model with:', {
        cashCollection: this.cashCollection,
        itemCost: this.itemCost,
        subtractDeliveryFee: this.subtractDeliveryFee,
        subtractPickupFee: this.subtractPickupFee,
      });

      // Preserve existing location data if no new location is provided
      const existingDropoff = this.dropoffModel[0];
      const currentLocation = existingDropoff?.location || {
        longitude: 0,
        latitude: 0,
        address: '',
        destinationAddress: '',
      };

      this.dropoffModel = [
        {
          packageSize: this.selectedPackageSize?.id || 2,
          sendingItemKey:
            this.form.get('selectedHandlingItem')?.value?.id ||
            this.selectedPackage?.id ||
            4,
          location: {
            longitude: location?.longitude || currentLocation.longitude || 0,
            latitude: location?.latitude || currentLocation.latitude || 0,
            address:
              location?.address ||
              this.form.get('dropoffLocation').value ||
              currentLocation.address ||
              '',
            destinationAddress:
              location?.destinationAddress ||
              currentLocation.destinationAddress ||
              '',
          },
          deliveryPlan: (() => {
            const plan = this.deliveryPlan || 'regular';
            return plan === 'express' ? 1 : plan === 'regular' ? 2 : 3;
          })(),
          collectCash: this.cashCollection ? this.itemCost : 0,
          isPhlenuTrustCheckApplied: this.trustCheck ? 1 : 0,
          id: existingDropoff?.id || Date.now().toString(),
          isCoverEnabled: this.securityCover ? 1 : 0,
          isDoorToDoorDropoff: this.dropoffType === 'door' ? 1 : 0,
          // Preserve existing location data or use new location data
          name:
            this.form.get('dropoffName')?.value ||
            location?.name ||
            existingDropoff?.name ||
            '',
          phone:
            this.form.get('dropoffPhone')?.value ||
            location?.phone ||
            location?.mobile ||
            existingDropoff?.phone ||
            '',
          phoneCode:
            location?.countryCode ||
            location?.dialCode ||
            existingDropoff?.phoneCode ||
            this.selectedCountryCode ||
            '',
          sendingItemName: this.getIndividualSendingItemName(existingDropoff),
        },
      ];

      console.log('Updated dropoff model:', this.dropoffModel[0]);
    }
  }

  // Helper method to get sending item name for individual sender
  private getIndividualSendingItemName(existingDropoff?: any): string {
    const selectedItem = this.form.get('selectedHandlingItem')?.value;

    // If "Other" is selected (id === 0), use attachmentInfo value
    if (selectedItem?.id === 0) {
      return this.form.get('attachmentInfo')?.value || 'Other';
    }

    // Otherwise use the item title/name
    return (
      selectedItem?.title ||
      selectedItem?.name ||
      this.selectedPackage?.name ||
      existingDropoff?.sendingItemName ||
      ''
    );
  }

  // Helper method to get sending item name for business sender
  private getBusinessSendingItemName(
    dropoffIndex: number,
    selectedSubItem?: any,
    existingDropoff?: any
  ): string {
    // If "Other" is selected (id === 0), use attachmentInfo value from the specific dropoff
    if (selectedSubItem?.id === 0) {
      const dropoffControl = this.dropoffLocations.controls[dropoffIndex];
      return dropoffControl?.get('attachmentInfo')?.value || 'Other';
    }

    // Otherwise use the item title/name
    return (
      selectedSubItem?.title ||
      selectedSubItem?.name ||
      existingDropoff?.sendingItemName ||
      ''
    );
  }

  // Update dropoff model for business sender
  updateBusinessDropoffModel() {
    if (this.senderType === 'business') {
      // Check if dropoffLocations exists and has controls
      if (!this.dropoffLocations || !this.dropoffLocations.controls) {
        console.warn(
          'DropoffLocations controls not available, skipping update'
        );
        return;
      }

      // Preserve existing dropoff model before clearing
      const existingDropoffModel = [...this.dropoffModel];

      this.dropoffModel = [];

      this.dropoffLocations.controls.forEach((group, index) => {
        // Skip if group is null or invalid
        if (!group) {
          console.warn(`Dropoff group at index ${index} is null, skipping`);
          return;
        }

        const dropoffPoint = group.get('dropoffPoint')?.value;
        const dropoffAddress = group.get('dropoffPointAddress')?.value;
        const contactPerson = group.get('contactPerson')?.value;
        const personNumber = group.get('personNumber')?.value;
        const packageSize = group.get('packageSize')?.value;
        const selectedSubItem = group.get('selectedSubItem')?.value;
        const isCashCollected = group.get('isCashCollected')?.value;
        const collectCash = group.get('collectCash')?.value;
        const isPhlenuTrustCheckApplied = group.get(
          'isPhlenuTrustCheckApplied'
        )?.value;
        const isSecurityCoverApplied = group.get(
          'isSecurityCoverApplied'
        )?.value;
        const isDoorToDoorDropoff = group.get('isDoorToDoorDropoff')?.value;
        const landMark = group.get('landMark')?.value;

        // Find existing dropoff data by ID to preserve location information
        const existingDropoff = existingDropoffModel.find(
          (d) => d.id === group.get('id')?.value
        );
        const existingLocation = existingDropoff?.location || {
          longitude: 0,
          latitude: 0,
          address: '',
          destinationAddress: '',
        };

        // Create dropoff model entry for all dropoff locations, even if incomplete
        const dropoff: DropoffModel = {
          packageSize: packageSize?.id || 2,
          sendingItemKey: selectedSubItem?.id || 4,
          location: {
            longitude:
              dropoffPoint?.longitude || existingLocation.longitude || 0,
            latitude: dropoffPoint?.latitude || existingLocation.latitude || 0,
            address: dropoffAddress || existingLocation.address || '',
            destinationAddress:
              dropoffPoint?.destinationAddress ||
              existingLocation.destinationAddress ||
              dropoffAddress ||
              '',
          },
          deliveryPlan: (() => {
            const plan =
              group.get('deliveryPlan')?.value ||
              this.deliveryPlan ||
              'regular';
            return plan === 'express' ? 1 : plan === 'regular' ? 2 : 3;
          })(),
          collectCash: isCashCollected ? parseFloat(collectCash) || 0 : 0,
          isPhlenuTrustCheckApplied: isPhlenuTrustCheckApplied ? 1 : 0,
          isSecurityCoverApplied: isSecurityCoverApplied ? 1 : 0,
          id: group.get('id')?.value || Date.now().toString() + String(index),
          isCoverEnabled: isSecurityCoverApplied ? 1 : 0,
          isDoorToDoorDropoff: isDoorToDoorDropoff ? 1 : 0,
          contactPerson:
            contactPerson ||
            dropoffPoint?.name ||
            existingDropoff?.contactPerson ||
            '',
          personNumber:
            personNumber ||
            dropoffPoint?.phone ||
            dropoffPoint?.mobile ||
            existingDropoff?.personNumber ||
            '',
          landMark: landMark || existingDropoff?.landMark || '',
          // Preserve existing location data or use new location data
          name:
            contactPerson || dropoffPoint?.name || existingDropoff?.name || '',
          phone:
            personNumber ||
            dropoffPoint?.phone ||
            dropoffPoint?.mobile ||
            existingDropoff?.phone ||
            '',
          phoneCode:
            dropoffPoint?.countryCode ||
            dropoffPoint?.dialCode ||
            existingDropoff?.phoneCode ||
            this.selectedCountryCode ||
            '',
          sendingItemName: this.getBusinessSendingItemName(
            index,
            selectedSubItem,
            existingDropoff
          ),
        };

        this.dropoffModel.push(dropoff);
      });

      // Update main order level properties based on dropoff data
      this.updateBusinessCashCollection();
    }
  }

  // Update specific dropoff in model
  updateSpecificDropoffInModel(index: number, location: any) {
    console.log('Updating specific dropoff in model:', {
      index: index,
      senderType: this.senderType,
      currentDropoffModelLength: this.dropoffModel.length,
      location: location,
    });

    if (this.senderType === 'business') {
      // First, ensure the dropoffModel array has enough entries
      while (this.dropoffModel.length <= index) {
        this.dropoffModel.push(
          this.createDropoffModel(this.dropoffModel.length)
        );
      }

      // Only update location if location data is actually provided
      if (
        location &&
        (location.longitude || location.latitude || location.address)
      ) {
        // Update the location for the specific index
        const newLocation = {
          longitude: location?.longitude || 0,
          latitude: location?.latitude || 0,
          address: location?.address || '',
          destinationAddress:
            location?.destinationAddress || location?.address || '',
        };

        console.log('Updating location for dropoff index', index, ':', {
          oldLocation: this.dropoffModel[index].location,
          newLocation: newLocation,
        });

        this.dropoffModel[index].location = newLocation;
      }

      // Also update other fields if they exist in the form
      const formGroup = this.dropoffLocations.controls[index];
      if (formGroup) {
        const contactPerson = formGroup.get('contactPerson')?.value;
        const personNumber = formGroup.get('personNumber')?.value;
        const packageSize = formGroup.get('packageSize')?.value;
        const selectedSubItem = formGroup.get('selectedSubItem')?.value;
        const isCashCollected = formGroup.get('isCashCollected')?.value;
        const collectCash = formGroup.get('collectCash')?.value;
        const isPhlenuTrustCheckApplied = formGroup.get(
          'isPhlenuTrustCheckApplied'
        )?.value;
        const isSecurityCoverApplied = formGroup.get(
          'isSecurityCoverApplied'
        )?.value;
        const isDoorToDoorDropoff = formGroup.get('isDoorToDoorDropoff')?.value;
        const landMark = formGroup.get('landMark')?.value;

        // Update name and phone from location data if available
        if (location?.name) {
          this.dropoffModel[index].name = location.name;
          // Also update contactPerson if it's empty
          if (!contactPerson) {
            this.dropoffModel[index].contactPerson = location.name;
          }
        } else if (contactPerson) {
          this.dropoffModel[index].contactPerson = contactPerson;
          this.dropoffModel[index].name = contactPerson;
        }

        if (location?.phone || location?.mobile) {
          this.dropoffModel[index].phone = location.phone || location.mobile;
          // Also update personNumber if it's empty
          if (!personNumber) {
            this.dropoffModel[index].personNumber =
              location.phone || location.mobile;
          }
        } else if (personNumber) {
          this.dropoffModel[index].personNumber = personNumber;
          this.dropoffModel[index].phone = personNumber;
        }

        if (packageSize?.id)
          this.dropoffModel[index].packageSize = packageSize.id;
        if (selectedSubItem?.id) {
          this.dropoffModel[index].sendingItemKey = selectedSubItem.id;
          this.dropoffModel[index].sendingItemName =
            selectedSubItem.title || selectedSubItem.name || '';
        }
        if (isCashCollected)
          this.dropoffModel[index].collectCash = parseFloat(collectCash) || 0;
        // Update per-dropoff delivery plan in model
        const plan =
          formGroup.get('deliveryPlan')?.value ||
          this.deliveryPlan ||
          'regular';
        this.dropoffModel[index].deliveryPlan =
          plan === 'express' ? 1 : plan === 'regular' ? 2 : 3;
        this.dropoffModel[index].isPhlenuTrustCheckApplied =
          isPhlenuTrustCheckApplied ? 1 : 0;
        this.dropoffModel[index].isSecurityCoverApplied = isSecurityCoverApplied
          ? 1
          : 0;
        this.dropoffModel[index].isCoverEnabled = isSecurityCoverApplied
          ? 1
          : 0;
        this.dropoffModel[index].isDoorToDoorDropoff = isDoorToDoorDropoff
          ? 1
          : 0;
        if (landMark) this.dropoffModel[index].landMark = landMark;

        // Update phoneCode from location data or selected country code
        this.dropoffModel[index].phoneCode =
          location?.countryCode ||
          location?.dialCode ||
          this.selectedCountryCode ||
          '';
      }

      console.log(
        'Updated dropoff model at index',
        index,
        ':',
        this.dropoffModel[index]
      );
    } else if (this.senderType === 'individual') {
      this.updateIndividualDropoffModel(location);
    }
  }

  // Helper method to preserve existing dropoff data
  preserveExistingDropoffData(
    index: number,
    newData: Partial<DropoffModel>
  ): DropoffModel {
    const existingDropoff = this.dropoffModel[index];
    if (existingDropoff) {
      return {
        ...existingDropoff,
        ...newData,
        location: {
          ...existingDropoff.location,
          ...(newData.location || {}),
        },
      };
    }
    return newData as DropoffModel;
  }

  // Sync model to Firebase
  syncModelToFirebase() {
    if (this.docIdFire) {
      const params = {
        dropOff: this.dropoffModel,
        // Only set changeStatus to 1 if user has clicked "Review Order"
        changeStatus: this.isReviewOrderClicked ? 1 : 0,
      };

      // Add fee deduction settings based on sender type
      if (this.senderType === 'individual') {
        params['isSubtractPriceFromDeliveryFee'] = this.subtractDeliveryFee
          ? 1
          : 0;
        params['isSubtractPriceFromPickUpFee'] = this.subtractPickupFee ? 1 : 0;
      } else if (this.senderType === 'business') {
        params['isSubtractPriceFromDeliveryFee'] = this.subtractDeliveryFee
          ? 1
          : 0;
        params['isSubtractPriceFromPickUpFee'] = this.subtractPickupFee ? 1 : 0;
      }

      // Add main order level properties based on sender type
      if (this.senderType === 'individual') {
        // For individual sender, use the component properties
        params['isCoverEnabled'] = this.securityCover ? 1 : 0;
        params['isPhlenuTrustCheckApplied'] = this.trustCheck ? 1 : 0;
        params['isCashCollectionApplied'] = this.cashCollection ? 1 : 0;
      } else if (this.senderType === 'business') {
        // For business sender, check if any dropoff has these features enabled
        const hasAnyTrustCheck = this.dropoffLocations.controls.some(
          (control) => control.get('isPhlenuTrustCheckApplied').value
        );
        const hasAnyCashCollection = this.dropoffLocations.controls.some(
          (control) => control.get('isCashCollected').value
        );
        const hasAnySecurityCover = this.dropoffLocations.controls.some(
          (control) => control.get('isSecurityCoverApplied').value
        );

        params['isCoverEnabled'] = hasAnySecurityCover ? 1 : 0;
        params['isPhlenuTrustCheckApplied'] = hasAnyTrustCheck ? 1 : 0;
        params['isCashCollectionApplied'] = hasAnyCashCollection ? 1 : 0;
      }

      console.log('Syncing model to Firebase:', {
        docId: this.docIdFire,
        dropoffModel: this.dropoffModel,
        params: params,
      });

      // Debug: Log each dropoff's isCoverEnabled value
      if (this.senderType === 'business' && this.dropoffModel.length > 0) {
        console.log('Dropoff isCoverEnabled values:');
        this.dropoffModel.forEach((dropoff, index) => {
          console.log(
            `Dropoff ${index}: isCoverEnabled = ${dropoff.isCoverEnabled}, isSecurityCoverApplied = ${dropoff.isSecurityCoverApplied}`
          );
        });
      }

      // Use batched update instead of immediate update
      this.updateDocWithParams(params);

      // Removed immediate refresh - only refresh when explicitly needed
    } else {
      console.warn('docIdFire is not set, cannot sync to Firebase');
    }

    // Also save to localStorage
    this.saveDataInfoLocal();
  }

  // Force refresh payment summary data from Firebase
  refreshPaymentSummaryData() {
    if (!this.docIdFire) {
      console.warn('docIdFire is not set, cannot refresh payment summary');
      return;
    }

    console.log('Forcing refresh of payment summary data...');
    const docRef = this.afs.collection(interRegional).doc(this.docIdFire);
    docRef.get().subscribe(
      (doc) => {
        if (doc.exists) {
          const data = doc.data();
          console.log('Refreshed Firebase data:', data);
          this.orderDoc = data;
          this.pool = data;
          console.log('Updated this.pool after refresh:', this.pool);
          this.cdr.detectChanges();
        } else {
          console.warn('Document does not exist');
        }
      },
      (error) => {
        console.error('Error refreshing payment summary data:', error);
      }
    );
  }

  // Optimized payment summary update - reduced Firebase operations
  handlePaymentSummaryUpdate() {
    console.log('Handling payment summary update...');
    // Only sync model to Firebase (no immediate refresh)
    this.syncModelToFirebase();

    // Refresh payment summary data only once after a longer delay
    setTimeout(() => {
      this.refreshPaymentSummaryData();
    }, 5000); // Increased delay to reduce read operations
  }

  // Add method to update derived properties
  updateDerivedProperties() {
    // Update derived properties based on orderDetail and dropDetail
    this.isPhlenuTrustCheckApplied =
      this.orderDetail?.isPhlenuTrustCheckApplied == 1 ||
      this.dropDetail?.some(
        (item: any) => item?.isPhlenuTrustCheckApplied == 1
      );

    this.isCashCollectionApplied =
      this.orderDetail?.isCashCollectionApplied == 1 ||
      this.dropDetail?.some((item: any) => item?.isCashCollectionApplied > 0);

    // Set business cash collection state
    if (this.senderType === 'business') {
      this.isCashCollection = this.isCashCollectionApplied;
      // Initialize the business cash collection state
      this.initializeBusinessCashCollectionState();
    }

    // Format order date
    if (this.orderDetail?.createdDate) {
      const createdDate = new Date(this.orderDetail.createdDate);
      const currentYear = new Date().getFullYear();

      if (createdDate.getFullYear() === currentYear) {
        this.orderDate =
          createdDate.toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
          }) +
          ', ' +
          createdDate.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
      } else {
        this.orderDate =
          createdDate.toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric',
          }) +
          ' - ' +
          createdDate.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
      }
    }

    // Set other properties
    this.orderNumber = this.orderDetail?.order_number || '';
    this.expectedDeliveryTime = this.orderDetail?.expectedDeliveryTime || '';
    this.pickupName = this.orderDetail?.pickUpName || '';
    this.pickupPhone = this.orderDetail?.pickUpPhone || '';
    this.pickupAddress = this.orderDetail?.pickUpAddress || '';
  }

  // Add method to get country currency
  getCountryCurrency(): string {
    const country = localStorage.getItem('country') || 'Ghana';
    return country === 'Nigeria' ? 'NGN' : 'GHS';
  }

  // Individual sender type methods (adapted from React code)
  selectDeliveryPlan(plan: any) {
    this.selectedDeliveryPlan = plan;
    this.updateDeliveryPlan(plan);

    // Update dropoff model
    this.updateIndividualDropoffModel();
    this.syncModelToFirebase();
  }

  selectPackageSize(packageSize: any) {
    this.selectedPackageSize = packageSize;
    this.updatePackageDetails();

    // Update dropoff model
    this.updateIndividualDropoffModel();
    this.syncModelToFirebase();

    // Save to localStorage immediately
    this.saveDataInfoLocal();

    // Trigger payment summary update
    this.handlePaymentSummaryUpdate();
  }

  selectPackage(packageItem: any) {
    this.selectedPackage = packageItem;
    this.updatePackageDetails();

    // Update dropoff model
    this.updateIndividualDropoffModel();
    this.syncModelToFirebase();

    // Save to localStorage immediately
    this.saveDataInfoLocal();
  }

  toggleTrustCheck() {
    this.trustCheck = !this.trustCheck;
    this.updateTrustCheck();

    // Update dropoff model
    this.updateIndividualDropoffModel();
    this.syncModelToFirebase();

    // Trigger payment summary update
    this.handlePaymentSummaryUpdate();
  }

  toggleSecurityCover() {
    this.securityCover = !this.securityCover;
    this.updateSecurityCover();

    // Update dropoff model
    this.updateIndividualDropoffModel();
    this.syncModelToFirebase();

    // Trigger payment summary update
    this.handlePaymentSummaryUpdate();
  }

  toggleCashCollection() {
    this.cashCollection = !this.cashCollection;
    if (!this.cashCollection) {
      this.subtractDeliveryFee = false;
      this.subtractPickupFee = false;
      this.itemCost = 0;

      // For individual sender type: reset form itemCost value and flags
      if (this.senderType === 'individual') {
        this.form.get('itemCost')?.setValue('');
        this.isItemCostApplied = false;
        this.isItemCostUpdating = false;

        // Toggle off security cover when cash collection is turned off
        this.securityCover = false;
        this.updateSecurityCover();
      }
    }
    this.selectedPaymentMethod = null;

    // Update dropoff model
    this.updateIndividualDropoffModel();
    this.syncModelToFirebase();

    // Trigger payment summary update
    this.handlePaymentSummaryUpdate();
  }

  updateItemCost() {
    const itemCostValue = this.form.get('itemCost').value;
    console.log('updateItemCost called with itemCost:', itemCostValue);
    console.log('Type of itemCost:', typeof itemCostValue);
    console.log('Cash collection status:', this.cashCollection);

    if (itemCostValue && parseFloat(itemCostValue) > 0) {
      this.isItemCostUpdating = true;
      console.log('Updating item cost to:', parseFloat(itemCostValue));

      // Update the itemCost property
      this.itemCost = itemCostValue;

      // Update dropoff model with new item cost
      this.updateIndividualDropoffModel();
      console.log('Updated dropoff model:', this.dropoffModel);

      // Sync to Firebase
      this.syncModelToFirebase();

      this.isItemCostUpdating = false;
      this.isItemCostApplied = true; // Set this to true after successful update

      // Trigger payment summary update
      this.handlePaymentSummaryUpdate();
    } else {
      console.log('Invalid item cost:', itemCostValue);
    }
  }

  // Add a new method to handle input changes without immediate update
  onItemCostInput(event: any) {
    console.log('Input event value:', event.target.value);
    console.log('Current itemCost property:', this.itemCost);

    // Reset the applied state when user changes the input
    if (this.isItemCostApplied) {
      this.isItemCostApplied = false;
    }

    // Don't call updateItemCost here, let the Apply button handle it
  }

  // Business flow item cost methods
  updateBusinessItemCost(dropoffIndex: number) {
    const dropoff = this.dropoffLocations.controls[dropoffIndex];
    const collectCashValue = dropoff.get('collectCash').value;
    console.log(
      'updateBusinessItemCost called with collectCash:',
      collectCashValue
    );
    console.log('Type of collectCash:', typeof collectCashValue);

    if (collectCashValue && parseFloat(collectCashValue) > 0) {
      this.isBusinessItemCostUpdating = true;
      console.log(
        'Updating business item cost to:',
        parseFloat(collectCashValue)
      );

      // Update the collectCash value in the form
      dropoff.get('collectCash').setValue(collectCashValue);

      // Set cash collection as enabled for this dropoff
      dropoff.get('isCashCollected').setValue(true);

      // Update the dropoff model with new item cost
      this.updateBusinessDropoffModel();
      console.log('Updated business dropoff model:', this.dropoffModel);

      // Update the specific dropoff in Firebase
      this.updateSpecificDropoffInModel(dropoffIndex, {
        collectCash: parseFloat(collectCashValue),
        isCashCollected: true,
      });

      // Sync the complete model to Firebase
      this.syncModelToFirebase();

      this.isBusinessItemCostUpdating = false;
      this.isBusinessItemCostApplied[dropoffIndex] = true; // Set this to true after successful update

      // Trigger payment summary update
      this.handlePaymentSummaryUpdate();

      // Show success message
      this._matSnackBar.open('Item cost updated successfully!', 'OK', {
        duration: 3000,
      });
    } else {
      console.log('Invalid business item cost:', collectCashValue);
      this._matSnackBar.open(
        'Please enter a valid amount greater than 0',
        'OK',
        { duration: 3000 }
      );
    }
  }

  // Add a new method to handle business input changes without immediate update
  onBusinessItemCostInput(event: any, dropoffIndex: number) {
    console.log('Business input event value:', event.target.value);
    console.log('Current collectCash property for dropoff:', dropoffIndex);

    // Reset the applied state when user changes the input
    if (this.isBusinessItemCostApplied[dropoffIndex]) {
      this.isBusinessItemCostApplied[dropoffIndex] = false;
    }

    // Don't call updateBusinessItemCost here, let the Apply button handle it
  }

  selectPaymentMethod(paymentMethod: any) {
    this.selectedPaymentMethod = paymentMethod;
    this.updatePaymentMethod(paymentMethod);
  }

  // Firebase update methods for Individual sender type
  updatePickupAndDropOnFirebase() {
    const updateParams = this.addChangeStatusToParams({
      isDoorToDoorPickup: this.pickupType === 'door' ? 1 : 0,
      pickup: {
        address: this.form.get('pickupLocation').value,
        // Add latitude/longitude if available
      },
      // Use arrayUnion to add to the array, or set the entire array
      dropOff: [
        {
          location: {
            address: this.form.get('dropoffLocation').value,
            // Add latitude/longitude if available
          },
          isDoorToDoorDropoff: this.dropoffType === 'door' ? 1 : 0,
          id: Date.now().toString(),
          isCoverEnabled: this.securityCover ? 1 : 0,
          isPhlenuTrustCheckApplied: this.trustCheck ? 1 : 0,
        },
      ],
    });
    this.updateDocWithParams(updateParams);
  }

  // For individual sender type - update specific array index

  // Add the missing updatePaymentMethod method
  updatePaymentMethod(paymentMethod: any) {
    const params = this.addChangeStatusToParams({
      paymentMethod: paymentMethod?.id || 1,
    });
    this.updateDocWithParams(params);
  }

  confirmOrder() {
    // Block if no payment method is selected
    if (!this.selectedPaymentMethod) {
      this._matSnackBar.open('Please select a payment method', 'OKAY', {
        duration: 3000,
      });
      return;
    }

    // Set loading state
    this.isConfirmingOrder = true;
    this.form.disable();

    // Get document data from Firebase
    if (!this.docIdFire) {
      console.error('docIdFire is not set, cannot confirm order');
      this._matSnackBar.open(
        'Order data not found. Please try again.',
        'OKAY',
        { duration: 5000 }
      );
      this.isConfirmingOrder = false;
      this.form.enable();
      return;
    }

    // Get the latest document data from Firebase
    const docRef = this.afs.collection(interRegional).doc(this.docIdFire);
    docRef.get().subscribe(
      (doc) => {
        if (doc.exists) {
          const firebaseData: any = doc.data();
          console.log('Firebase document data:', firebaseData);

          // Add required properties to Firebase data following bulk order pattern
          const orderData = {
            ...firebaseData,
            placedFrom: 1,
            finalizeOrder: 0,
            isWebOrder: 1,
            paymentType: this.selectedPaymentMethod?.id,
            isWalletUsed: this.selectedPaymentMethod?.id === 4 ? 1 : 0,
          };

          console.log('Order data with additional properties:', orderData);

          // Send the enhanced data to API
          this._authService.confirmInterRegionalOrder(orderData).subscribe({
            next: (res: any) => {
              console.log('Order confirmation response:', res);

              if (res?.response == 2) {
                // Payment required - check if payment URL is provided
                if (res?.data?.paymentLink && res?.data?.isPaid) {
                  this._matSnackBar.open('Processing payment...', 'OKAY', {
                    duration: 5000,
                  });
                  // Open payment URL in new window/tab
                  this.handlePaymentRedirect(res.data);
                } else {
                  this.isOrderConfirmed = true;
                  this._matSnackBar.open(
                    'Order confirmed successfully!',
                    'OKAY',
                    { duration: 5000 }
                  );
                  this.confirmOrderRes = res;
                  this.handleOrderConfirmationResponse(res);
                }
              } else if (res?.response == 1) {
                // Order confirmed successfully
                this.isOrderConfirmed = true;
                // this._matSnackBar.open('Order confirmed successfully!', 'OKAY', { duration: 5000 });
                this.confirmOrderRes = res;
                this.handleOrderConfirmationResponse(res);
              } else if (res?.response == 3) {
                // Delivery window closed
                this._matSnackBar.open(
                  res.message || 'Delivery window is closed',
                  'OKAY',
                  { duration: 5000 }
                );
                this.form.enable();
                this.isConfirmingOrder = false;
              } else {
                // Other errors
                this._matSnackBar.open(
                  res.message || 'Order confirmation failed',
                  'OKAY',
                  { duration: 5000 }
                );
                this.form.enable();
                this.isConfirmingOrder = false;
              }
            },
            error: (error) => {
              console.error('Error confirming order:', error);
              this._matSnackBar.open(
                'Failed to confirm order. Please try again.',
                'OKAY',
                { duration: 5000 }
              );
              this.form.enable();
              this.isConfirmingOrder = false;
            },
          });
        } else {
          console.error('Firebase document does not exist');
          this._matSnackBar.open(
            'Order data not found. Please try again.',
            'OKAY',
            { duration: 5000 }
          );
          this.form.enable();
          this.isConfirmingOrder = false;
        }
      },
      (error) => {
        console.error('Error fetching Firebase document:', error);
        this._matSnackBar.open(
          'Failed to fetch order data. Please try again.',
          'OKAY',
          { duration: 5000 }
        );
        this.form.enable();
        this.isConfirmingOrder = false;
      }
    );
  }

  private handlePaymentRedirect(paymentData: any): void {
    console.log('paymentData', paymentData);

    // Store order data for payment confirmation
    localStorage.setItem(
      'PENDINGINTERREGIONALORDERDATA',
      JSON.stringify({
        orderData: {
          ...paymentData,
        },
      })
    );

    // Mark to preserve local data during redirect/navigation
    this.orderConfirmApiCalled = true;
    sessionStorage.setItem('PRESERVE_PENDING_INTERREGIONALORDERDATA', '1');

    // Open payment URL in new window/tab
    window.open(paymentData.paymentLink, '_self');

    // Reset form and state
    this.form.enable();
    this.isConfirmingOrder = false;
  }

  private handleOrderConfirmationResponse(paymentData: any): void {
    this.orderConfirmApiCalled = true;

    console.log('paymentData', paymentData);

    localStorage.setItem(
      'PENDINGINTERREGIONALORDERDATA',
      JSON.stringify({
        orderData: {
          ...paymentData,
        },
      })
    );

    // Mark to preserve local data during navigation to success page
    sessionStorage.setItem('PRESERVE_PENDING_INTERREGIONALORDERDATA', '1');

    try {
      this._authService.getDashboardData();
    } catch (e) {
      console.warn(
        'Failed to refresh dashboard data after order confirmation',
        e
      );
    }

    // Navigate to the correct payment success route based on country
    const paymentSuccessRoute =
      this.country === 'Ghana'
        ? '/inter-regional-payment-success'
        : '/inter-state-payment-success';
    this._router.navigate([paymentSuccessRoute]);

    // Reset form and state
    this.form.enable();
    this.isConfirmingOrder = false;
  }

  /* 
    HANDLE ORDER WITH LOCAL STORAGE
  */

  saveDataInfoLocal() {
    if (this.isOrderConfirmed) return;

    if (this.form.get('pickupLocation')?.value) {
      // Prepare form data with all necessary information
      const formData = {
        ...this.form.value,
        // Ensure we save the current state of arrays with selections
        packsizes: JSON.parse(JSON.stringify(this.packsizes)),
        handlingMethods: JSON.parse(JSON.stringify(this.handlingMethods)),
        handlingData: this.handlingData
          ? JSON.parse(JSON.stringify(this.handlingData))
          : null,
        paymentMethods: JSON.parse(JSON.stringify(this.paymentMethods)),
      };

      // For business sender, ensure dropoff locations have complete data
      if (
        this.senderType === 'business' &&
        this.dropoffLocations.controls.length > 0
      ) {
        formData.dropoffLocations = this.dropoffLocations.controls.map(
          (control) => ({
            ...control.value,
            // Ensure package sizes and handling items are saved with their selection state
            packageSizes: JSON.parse(
              JSON.stringify(control.get('packageSizes').value)
            ),
            handlingItems: JSON.parse(
              JSON.stringify(control.get('handlingItems').value)
            ),
            handlingSubItems: control.get('handlingSubItems').value
              ? JSON.parse(
                  JSON.stringify(control.get('handlingSubItems').value)
                )
              : null,
          })
        );
      }

      const pendingOrderData = {
        formData: formData,
        docIdFire: JSON.parse(JSON.stringify(this.docIdFire)),
        senderType: this.senderType,
        pickupType: this.pickupType,
        dropoffType: this.dropoffType,
        deliveryPlan: this.deliveryPlan,
        selectedDeliveryPlan: this.selectedDeliveryPlan || null,
        selectedPackageSize: this.selectedPackageSize || null,
        selectedPackage: this.selectedPackage || null,
        trustCheck: this.trustCheck || false,
        securityCover: this.securityCover || false,
        cashCollection: this.cashCollection || false,
        isCashCollection: this.isCashCollection || false, // Add this line
        subtractDeliveryFee: this.subtractDeliveryFee || false,
        subtractPickupFee: this.subtractPickupFee || false,
        itemCost: this.itemCost || '',
        isBusinessItemCostUpdating: this.isBusinessItemCostUpdating || false,
        isBusinessItemCostApplied: this.isBusinessItemCostApplied || {},
        isBusinessSecurityCoverApplied:
          this.isBusinessSecurityCoverApplied || {},
        selectedPaymentMethod: this.selectedPaymentMethod || null,
        dropoffModel: this.dropoffModel || [],
        dropoffCount: this.dropoffCount || 1,
        stepIndex: this.stepIndex || 0,
        selectedIndex: this.selectedIndex || 1,
        isBusinessPartner: this.isBusinessPartner || false,
        isReviewOrderClicked: this.isReviewOrderClicked,
      };

      localStorage.setItem(
        'PENDINGINTERREGIONALORDERDATA',
        JSON.stringify(pendingOrderData)
      );
      console.log('Order data saved to localStorage:', pendingOrderData);
    }
  }

  checkAndRestoreLocalData() {
    const savedData = localStorage.getItem('PENDINGINTERREGIONALORDERDATA');
    if (savedData) {
      try {
        this.pendingOrderData = JSON.parse(savedData);
        console.log('Found saved order data:', this.pendingOrderData);
        this.fillOrderDataByLocalData();
      } catch (error) {
        console.error('Error parsing saved order data:', error);
        localStorage.removeItem('PENDINGINTERREGIONALORDERDATA');
      }
    } else {
      console.log('No saved order data found');
    }
  }

  fillOrderDataByLocalData() {
    this.isRestoringFromLocal = true;
    this.form.disable();
    this.isDataLoading = true;

    console.log(
      'Restoring order data from localStorage:',
      this.pendingOrderData
    );

    // Restore docIdFire
    this.docIdFire = this.pendingOrderData?.docIdFire;

    // Subscribe to Firebase document if docIdFire is restored
    if (this.docIdFire) {
      this.subscribeDoc();
    }

    // Restore UI state first
    this.senderType = this.pendingOrderData?.senderType || 'individual';
    this.pickupType = this.pendingOrderData?.pickupType || 'door';
    this.dropoffType = this.pendingOrderData?.dropoffType || 'door';
    this.deliveryPlan = this.pendingOrderData?.deliveryPlan || 'regular';
    this.dropoffCount = this.pendingOrderData?.dropoffCount || 1;
    this.stepIndex = this.pendingOrderData?.stepIndex || 0;
    this.selectedIndex = this.pendingOrderData?.selectedIndex || 0;
    this.isBusinessPartner = this.pendingOrderData?.isBusinessPartner || false;
    this.isReviewOrderClicked =
      this.pendingOrderData?.isReviewOrderClicked || false;

    // Restore individual sender specific data
    this.selectedDeliveryPlan =
      this.pendingOrderData?.selectedDeliveryPlan || null;
    this.selectedPackageSize =
      this.pendingOrderData?.selectedPackageSize || null;
    this.selectedPackage = this.pendingOrderData?.selectedPackage || null;
    this.trustCheck = this.pendingOrderData?.trustCheck || false;
    this.securityCover = this.pendingOrderData?.securityCover || false;
    this.cashCollection = this.pendingOrderData?.cashCollection || false;
    this.isCashCollection = this.pendingOrderData?.isCashCollection || false; // Add this line
    this.subtractDeliveryFee =
      this.pendingOrderData?.subtractDeliveryFee || false;
    this.subtractPickupFee = this.pendingOrderData?.subtractPickupFee || false;
    this.itemCost = this.pendingOrderData?.itemCost || '';
    this.isBusinessItemCostUpdating =
      this.pendingOrderData?.isBusinessItemCostUpdating || false;
    this.isBusinessItemCostApplied =
      this.pendingOrderData?.isBusinessItemCostApplied || {};
    this.isBusinessSecurityCoverApplied =
      this.pendingOrderData?.isBusinessSecurityCoverApplied || {};
    this.selectedPaymentMethod =
      this.pendingOrderData?.selectedPaymentMethod || null;

    // Restore dropoff model
    if (this.pendingOrderData?.dropoffModel) {
      this.dropoffModel = this.pendingOrderData.dropoffModel;
    }

    // Restore form data
    if (this.pendingOrderData?.formData) {
      this.form.patchValue(this.pendingOrderData.formData);
    }

    // Restore dropoff locations for business sender
    if (this.pendingOrderData?.formData?.dropoffLocations) {
      this.restoreDropoffLocations(
        this.pendingOrderData.formData.dropoffLocations
      );
    }

    // Restore package sizes selection for individual sender
    if (
      this.senderType === 'individual' &&
      this.pendingOrderData?.formData?.packsizes
    ) {
      console.log(
        'Restoring package sizes for individual sender from saved data'
      );
      // Restore the entire packsizes array with selections
      this.packsizes = this.pendingOrderData.formData.packsizes;
      // Also restore the form value if we have a selected package size
      if (this.selectedPackageSize) {
        this.form.get('orderPackageSize')?.setValue(this.selectedPackageSize);
      }
    } else if (this.senderType === 'individual' && this.selectedPackageSize) {
      console.log(
        'Restoring package sizes for individual sender from selectedPackageSize:',
        this.selectedPackageSize
      );
      this.packsizes.forEach((item) => {
        item.isSelected = item.id === this.selectedPackageSize.id ? 1 : 0;
        console.log(`Package ${item.name}: isSelected = ${item.isSelected}`);
      });
      // Also restore the form value
      this.form.get('orderPackageSize')?.setValue(this.selectedPackageSize);
    }

    // Restore handling methods selection for individual sender
    if (
      this.senderType === 'individual' &&
      this.pendingOrderData?.formData?.handlingMethods
    ) {
      console.log(
        'Restoring handling methods for individual sender from saved data'
      );
      // Restore the entire handlingMethods array with selections
      this.handlingMethods = this.pendingOrderData.formData.handlingMethods;

      // Restore handling data if available
      if (this.pendingOrderData.formData.handlingData) {
        this.handlingData = this.pendingOrderData.formData.handlingData;
      }

      // Restore form values
      const selectedHandling = this.handlingMethods.find(
        (item) => item.isSelected
      );
      if (selectedHandling) {
        this.form.get('selectedHandlingMethod')?.setValue(selectedHandling);
      }

      // Restore selected package item
      if (this.selectedPackage && this.handlingData) {
        console.log(
          'Restoring package item for individual sender:',
          this.selectedPackage
        );
        this.handlingData.forEach((item) => {
          item.isSelected = item.id === this.selectedPackage.id ? 1 : 0;
          console.log(
            `Package item ${item.title}: isSelected = ${item.isSelected}`
          );
        });
        this.form.get('selectedHandlingItem')?.setValue(this.selectedPackage);
      }
    } else if (
      this.senderType === 'individual' &&
      this.pendingOrderData?.formData?.selectedHandlingMethod
    ) {
      this.handlingMethods.forEach((item) => {
        item.isSelected =
          item.id === this.pendingOrderData.formData.selectedHandlingMethod.id
            ? 1
            : 0;
      });

      // Restore handling data based on selected handling method
      const selectedHandling = this.handlingMethods.find(
        (item) => item.isSelected
      );
      if (selectedHandling) {
        this.form.get('selectedHandlingMethod')?.setValue(selectedHandling);

        // Initialize handling data based on selection
        if (selectedHandling?.id === 1) {
          // Packaged items
          this.handlingData = this.addNewKey(
            this.handlingAllData?.package || []
          );
        } else if (selectedHandling?.id === 2) {
          // Handle with care items
          this.handlingData = this.addNewKey(this.handlingAllData?.care || []);
        }

        // Restore selected package item
        if (this.selectedPackage) {
          console.log(
            'Restoring package item for individual sender:',
            this.selectedPackage
          );
          this.handlingData.forEach((item) => {
            item.isSelected = item.id === this.selectedPackage.id ? 1 : 0;
            console.log(
              `Package item ${item.title}: isSelected = ${item.isSelected}`
            );
          });
          this.form.get('selectedHandlingItem')?.setValue(this.selectedPackage);
        }
      }
    }

    // Force change detection by creating new array references
    if (this.senderType === 'individual') {
      this.packsizes = [...this.packsizes];
      this.handlingMethods = [...this.handlingMethods];
      if (this.handlingData) {
        this.handlingData = [...this.handlingData];
      }
      // Force change detection for individual sender
      this.cdr.detectChanges();
    }

    // Restore business sender specific data
    if (this.senderType === 'business') {
      // Restore package sizes and handling items for each dropoff location
      this.dropoffLocations.controls.forEach((control, index) => {
        const savedDropoff =
          this.pendingOrderData?.formData?.dropoffLocations?.[index];
        if (savedDropoff) {
          // Restore package sizes selection - use the saved array directly
          if (
            savedDropoff.packageSizes &&
            Array.isArray(savedDropoff.packageSizes)
          ) {
            console.log(
              `Restoring package sizes for dropoff ${index} from saved data`
            );
            control.get('packageSizes').setValue(savedDropoff.packageSizes);
          } else if (savedDropoff.packageSize) {
            console.log(
              `Restoring package sizes for dropoff ${index}:`,
              savedDropoff.packageSize
            );
            const packageSizes = control.get('packageSizes').value;
            packageSizes.forEach((item: any) => {
              item.isSelected =
                savedDropoff.packageSize?.id === item.id ? 1 : 0;
              console.log(
                `Dropoff ${index} Package ${item.name}: isSelected = ${item.isSelected}`
              );
            });
            // Update the form control value after modifying the array
            control.get('packageSizes').setValue(packageSizes);
          }

          // Restore handling items selection - use the saved array directly
          if (
            savedDropoff.handlingItems &&
            Array.isArray(savedDropoff.handlingItems)
          ) {
            console.log(
              `Restoring handling items for dropoff ${index} from saved data`
            );
            control.get('handlingItems').setValue(savedDropoff.handlingItems);
          } else if (savedDropoff.selectedHandlingItem) {
            const handlingItems = control.get('handlingItems').value;
            handlingItems.forEach((item: any) => {
              item.isSelected =
                savedDropoff.selectedHandlingItem?.id === item.id ? 1 : 0;
            });
            // Update the form control value after modifying the array
            control.get('handlingItems').setValue(handlingItems);
          }

          // Restore handling sub-items - use the saved array directly
          if (
            savedDropoff.handlingSubItems &&
            Array.isArray(savedDropoff.handlingSubItems)
          ) {
            console.log(
              `Restoring handling sub-items for dropoff ${index} from saved data`
            );
            control
              .get('handlingSubItems')
              .setValue(savedDropoff.handlingSubItems);
          } else {
            // Fallback: restore handling sub-items based on selected handling method
            const handlingItems = control.get('handlingItems').value;
            const selectedHandling = handlingItems.find(
              (item: any) => item.isSelected
            );
            if (selectedHandling) {
              if (selectedHandling?.id === 1) {
                control
                  .get('handlingSubItems')
                  .setValue(
                    this.addNewKey(this.handlingAllData?.package || [])
                  );
              } else if (selectedHandling?.id === 2) {
                control
                  .get('handlingSubItems')
                  .setValue(this.addNewKey(this.handlingAllData?.care || []));
              }

              // Restore selected sub-item
              if (savedDropoff.selectedSubItem) {
                console.log(
                  `Restoring sub-item for dropoff ${index}:`,
                  savedDropoff.selectedSubItem
                );
                const handlingSubItems = control.get('handlingSubItems').value;
                handlingSubItems.forEach((item: any) => {
                  item.isSelected =
                    savedDropoff.selectedSubItem?.id === item.id ? 1 : 0;
                  console.log(
                    `Dropoff ${index} Sub-item ${item.title}: isSelected = ${item.isSelected}`
                  );
                });
                // Update the form control value after modifying the array
                control.get('handlingSubItems').setValue(handlingSubItems);
              }
            }
          }
        }
      });
      // Force change detection for business sender
      this.cdr.detectChanges();
    }

    // Restore payment methods selection
    if (this.selectedPaymentMethod) {
      this.paymentMethods.forEach((item) => {
        item.isSelected = item.id === this.selectedPaymentMethod.id ? 1 : 0;
      });
    }

    this.form.enable();
    this.form.markAllAsTouched();
    this.isDataLoading = false;
    this.isRestoringFromLocal = false;

    // Force change detection by triggering a small delay
    setTimeout(() => {
      // Force Angular to detect changes
      this.form.updateValueAndValidity();
      this.cdr.detectChanges();
    }, 100);

    console.log('Order data restored successfully');
  }

  private restoreDropoffLocations(savedDropoffs: any[]) {
    console.log('Restoring dropoff locations:', savedDropoffs);

    // Clear existing dropoff locations
    this.dropoffLocations.clear();
    this.showDropoffDetails = [];

    // Add controls for each saved dropoff
    savedDropoffs.forEach((drop, index) => {
      const group = this.fb.group({
        dropoffPointAddress: [
          drop.dropoffPointAddress || '',
          Validators.required,
        ],
        dropoffPoint: [drop.dropoffPoint || '', Validators.required],
        contactPerson: [
          drop.contactPerson || '',
          [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z0-9 ]*$')],
        ],
        personNumber: [drop.personNumber || '', [Validators.required]],
        landMark: [drop.landMark || ''],
        isCashCollected: [drop.isCashCollected || false],
        collectCash: [drop.collectCash || ''],
        handlingItems: [drop.handlingItems || ''],
        packageSizes: [drop.packageSizes || []],
        selectedHandlingItem: [
          drop.selectedHandlingItem || '',
          Validators.required,
        ],
        packageSize: [drop.packageSize || '', Validators.required],
        handlingSubItems: [drop.handlingSubItems || ''],
        selectedSubItem: [drop.selectedSubItem || '', Validators.required],
        attachmentInfo: [drop.attachmentInfo || ''],
        attachment: [drop.attachment || ''],
        attachmentUrl: [drop.attachmentUrl || ''],
        isAttachmentUploaded: [drop.isAttachmentUploaded || ''],
        isPhlenuTrustCheckApplied: [drop.isPhlenuTrustCheckApplied || false],
        isSecurityCoverApplied: [drop.isSecurityCoverApplied || false],
        isDoorToDoorDropoff: [
          drop.isDoorToDoorDropoff !== undefined
            ? drop.isDoorToDoorDropoff
            : this.dropoffType === 'door',
        ],
        deliveryCharges: [drop.deliveryCharges || ''],
        distance: [drop.distance || ''],
        id: [drop.id || Date.now().toString() + String(index)],
      });

      // Set initial values for handlingItems and packageSizes if not already set
      if (!drop.handlingItems || !Array.isArray(drop.handlingItems)) {
        group.patchValue({
          handlingItems: JSON.parse(JSON.stringify(this.handlingMethods)),
        });
      }
      if (!drop.packageSizes || !Array.isArray(drop.packageSizes)) {
        group.patchValue({
          packageSizes: JSON.parse(JSON.stringify(this.packsizes)),
        });
      }

      // If we have saved data with selections, restore them directly
      if (drop.handlingItems && Array.isArray(drop.handlingItems)) {
        console.log(
          `Restoring handling items for dropoff ${index} from saved data`
        );
        group.get('handlingItems').setValue(drop.handlingItems);
      }

      if (drop.packageSizes && Array.isArray(drop.packageSizes)) {
        console.log(
          `Restoring package sizes for dropoff ${index} from saved data`
        );
        group.get('packageSizes').setValue(drop.packageSizes);
      }

      // Restore handling sub-items if we have saved data
      if (drop.handlingSubItems && Array.isArray(drop.handlingSubItems)) {
        console.log(
          `Restoring handling sub-items for dropoff ${index} from saved data`
        );
        group.get('handlingSubItems').setValue(drop.handlingSubItems);
      }

      this.dropoffLocations.push(group);
      this.showDropoffDetails.push(false);

      // Restore business item cost applied state
      if (
        this.senderType === 'business' &&
        drop.collectCash &&
        parseFloat(drop.collectCash) > 0
      ) {
        this.isBusinessItemCostApplied[index] = true;
      }

      // Restore business security cover applied state
      if (this.senderType === 'business') {
        this.isBusinessSecurityCoverApplied[index] =
          drop.isSecurityCoverApplied || false;
      }
    });

    console.log(
      'Dropoff locations restored:',
      this.dropoffLocations.controls.length
    );
    // Force change detection after restoring dropoff locations
    this.cdr.detectChanges();
  }

  // Payment summary methods (from React code)
  getDeliveryFee(): number {
    const basePrice =
      this.pool?.totalBasePrice +
      this.pool?.totalTrustCheckFee +
      this.pool?.totalCoverPrice +
      this.pool?.totalCashCollectionIncreaseAmount +
      this.pool?.totalBizPartnerCommissionIncAmt;
    if (
      this.pool?.isSubtractPriceFromDeliveryFee == 1 &&
      this.pool?.isSubtractPriceFromPickUpFee == 1
    ) {
      return basePrice + this.pool?.pickupFee + this.pool?.totalDropoffFee;
    }
    if (this.pool?.isSubtractPriceFromDeliveryFee == 1) {
      return basePrice + this.pool?.totalDropoffFee;
    }
    if (this.pool?.isSubtractPriceFromPickUpFee == 1) {
      return basePrice + this.pool?.pickupFee;
    }
    return basePrice;
  }

  // Helper method for payment summary display
  labelValueView(
    label: string,
    value: string,
    isFirst: boolean = false,
    isBlue: boolean = false
  ): any {
    return {
      label,
      value,
      isFirst,
      isBlue,
    };
  }

  // Method to get payment summary data for Individual sender type (based on React code)
  getPaymentSummaryData(): any[] {
    if (!this.pool) return [];

    const summaryData = [];

    // Delivery Charges
    summaryData.push(
      this.labelValueView(
        'Delivery Charges',
        `${this.pool?.totalBasePrice || 0}`
      )
    );

    // Dropoff Fee (if door-to-door dropoff)
    if (
      this.pool?.dropDetails?.some((item: any) => item?.isDoorToDoorDropoff) &&
      this.pool?.totalDropoffFee > 0
    ) {
      summaryData.push(
        this.labelValueView('Dropoff Fee', `${this.pool?.totalDropoffFee || 0}`)
      );
    }

    // Pickup Fee
    if (this.pool?.pickupFee > 0) {
      summaryData.push(
        this.labelValueView('Pickup Fee', `${this.pool?.pickupFee || 0}`)
      );
    }

    // Phlenu TrustCheck
    if (
      this.pool?.dropDetails?.some(
        (item: any) => item?.isPhlenuTrustCheckApplied
      )
    ) {
      summaryData.push(
        this.labelValueView(
          'Phlenu TrustCheck',
          `${this.pool?.totalTrustCheckFee || 0}`
        )
      );
    }

    // Security Cover Charges
    if (this.pool?.totalCoverPrice > 0) {
      summaryData.push(
        this.labelValueView(
          'Security Cover Charges',
          `${this.pool?.totalCoverPrice || 0}`
        )
      );
    }

    return summaryData;
  }

  // Computed properties for better performance and cleaner template
  get shouldShowPaymentSummary(): boolean {
    return this.stepIndex === 2 && this.pool;
  }

  // Method to check if payment summary skeleton should be shown
  shouldShowPaymentSummarySkeleton(): boolean {
    return this.isDataLoading || this.apiLoading || !this.pool;
  }

  // Helper methods for payment summary conditions
  hasDoorToDoorDropoff(): boolean {
    return (
      this.pool?.dropDetails?.some((item: any) => item?.isDoorToDoorDropoff) &&
      this.pool?.totalDropoffFee > 0
    );
  }

  hasPhlenuTrustCheck(): boolean {
    return this.pool?.dropDetails?.some(
      (item: any) => item?.isPhlenuTrustCheckApplied
    );
  }

  shouldShowTotalDeliveryFee(): boolean {
    return this.pool?.paymentDirection != 2;
  }

  shouldShowTotalItemCost(): boolean {
    return (
      this.cashCollection && this.itemCost && this.pool?.paymentDirection != 2
    );
  }

  shouldShowDeliveryFeeDeduction(): boolean {
    return (
      this.pool?.isSubtractPriceFromDeliveryFee == 1 ||
      this.pool?.isSubtractPriceFromPickUpFee == 1
    );
  }

  getPaymentDirectionLabel(): string {
    if (this.pool?.paymentDirection == 0) return 'Money to Be Paid';
    if (this.pool?.paymentDirection == 1) return 'Money to Be Returned';
    return 'Total Amount';
  }

  getFinalAmount(): number {
    if (this.pool?.paymentDirection == 2) {
      return this.pool?.totalCharges || 0;
    }
    return this.pool?.settlementAmount || 0;
  }

  // Update this method in your InterRegionalComponent class
  updateDropOffArray() {
    if (this.senderType === 'business') {
      // Use the model approach instead
      this.updateBusinessDropoffModel();
      this.syncModelToFirebase();
    }
  }

  updateDropOff() {
    // This method is called when the tab changes
    // Update the dropoff model and sync to Firebase
    if (
      this.senderType === 'business' &&
      this.dropoffLocations &&
      this.dropoffLocations.controls
    ) {
      this.updateBusinessDropoffModel();
      this.syncModelToFirebase();
    }
  }

  // Also update the updateSpecificDropoffLocation method
  updateSpecificDropoffLocation(dropoffIndex: number, location: any) {
    if (this.senderType === 'business') {
      // For business, update the specific dropoff in model
      this.updateSpecificDropoffInModel(dropoffIndex, location);
    } else {
      // For individual, update the entire array with the new location
      this.updateIndividualDropoffModel(location);
    }
    this.syncModelToFirebase();
  }

  // Add missing methods referenced in template
  updateBusinessTrustCheck() {
    if (
      this.senderType === 'business' &&
      this.dropoffLocations.controls[this.selectedIndex]
    ) {
      const currentValue = this.dropoffLocations.controls[
        this.selectedIndex
      ].get('isPhlenuTrustCheckApplied').value;
      this.dropoffLocations.controls[this.selectedIndex]
        .get('isPhlenuTrustCheckApplied')
        .setValue(!currentValue);

      // Update the dropoff model
      this.updateBusinessDropoffModel();

      // Check if any dropoff has trust check enabled and update main order level
      const hasAnyTrustCheck = this.dropoffLocations.controls.some(
        (control) => control.get('isPhlenuTrustCheckApplied').value
      );

      // Update main order level trust check
      const params = this.addChangeStatusToParams({
        isPhlenuTrustCheckApplied: hasAnyTrustCheck ? 1 : 0,
      });
      this.updateDocWithParams(params);

      this.syncModelToFirebase();
    }
  }

  updateBusinessSecurityCover() {
    // This method is called but not implemented in the template logic
    // For now, we'll leave it empty as the template doesn't show security cover for business
    console.log('Business security cover toggle - not implemented');

    // If security cover is implemented for business, update main order level
    // const params = {
    //   isCoverEnabled: this.securityCover ? 1 : 0,
    // };
    // this.updateDocWithParams(params);
  }

  // Add method to update main order level cash collection for business
  // Add method to handle business cash collection toggle
  toggleBusinessCashCollection(event?: MatSlideToggleChange) {
    // If user explicitly toggled, respect the checked state
    if (event) {
      this.isCashCollection = !!event.checked;
      // Clear import-applied flag on manual user action to avoid OR conflicts
      this.isCashCollectionApplied = false;
    } else {
      this.isCashCollection = !this.isCashCollection;
    }
    // Keep general cashCollection flag in sync for UI conditions that still rely on it
    this.cashCollection = this.isCashCollection;

    // Update all dropoff locations to reflect the cash collection state
    this.dropoffLocations.controls.forEach((control, index) => {
      control.get('isCashCollected').setValue(this.isCashCollection);

      // If cash collection is disabled, clear the collectCash value and turn off security cover
      if (!this.isCashCollection) {
        control.get('collectCash').setValue('');
        control.get('isSecurityCoverApplied').setValue(false); // Turn off security cover for this dropoff
        this.isBusinessItemCostApplied[index] = false;
        this.isBusinessSecurityCoverApplied[index] = false; // Reset security cover applied state

        // Update the dropoff model to reflect security cover being turned off
        if (this.dropoffModel[index]) {
          this.dropoffModel[index].isSecurityCoverApplied = 0;
          this.dropoffModel[index].isCoverEnabled = 0;
        }
      }
    });

    // Initialize order-level fee deduction settings if cash collection is enabled
    if (this.isCashCollection) {
      // Set default values for fee deductions (can be changed by user)
      this.subtractDeliveryFee = false;
      this.subtractPickupFee = false;
    } else {
      // If cash collection is disabled, reset subtraction settings to 0
      this.subtractDeliveryFee = false;
      this.subtractPickupFee = false;
    }

    // Update Firebase with the new cash collection state
    this.updateBusinessCashCollection();

    // Update subtraction settings in Firebase (set to 0 when cash collection is disabled)
    this.updateSubtractionSettingsOnFirebase();

    // Update the dropoff model
    this.updateBusinessDropoffModel();
    this.syncModelToFirebase();

    // Trigger payment summary update
    this.handlePaymentSummaryUpdate();

    // Show feedback to user
    const message = this.isCashCollection
      ? 'Cash collection enabled for all dropoff locations'
      : 'Cash collection disabled for all dropoff locations. Item costs, security cover, and fee deductions have been reset.';
    this._matSnackBar.open(message, 'OK', { duration: 3000 });
  }

  // Method to initialize business cash collection state from Firebase data
  initializeBusinessCashCollectionState() {
    if (this.senderType === 'business' && this.dropoffLocations) {
      // Check if any dropoff has cash collection enabled
      const hasAnyCashCollection = this.dropoffLocations.controls.some(
        (control) =>
          control.get('isCashCollected').value ||
          (control.get('collectCash').value &&
            parseFloat(control.get('collectCash').value) > 0)
      );

      this.isCashCollection = hasAnyCashCollection;
      // Keep general cashCollection flag in sync as some UI sections still depend on it
      this.cashCollection = hasAnyCashCollection;

      // Update the main cash collection state for all dropoffs
      this.dropoffLocations.controls.forEach((control, index) => {
        control.get('isCashCollected').setValue(this.isCashCollection);

        // Set applied state for dropoffs with valid cash amounts
        if (
          control.get('collectCash').value &&
          parseFloat(control.get('collectCash').value) > 0
        ) {
          this.isBusinessItemCostApplied[index] = true;
        }

        // Initialize security cover applied state
        const isSecurityCoverApplied = control.get(
          'isSecurityCoverApplied'
        )?.value;
        this.isBusinessSecurityCoverApplied[index] =
          isSecurityCoverApplied || false;
      });
    }
  }

  updateBusinessCashCollection() {
    if (this.senderType === 'business') {
      // Check if any dropoff has cash collection enabled
      const hasAnyCashCollection = this.dropoffLocations.controls.some(
        (control) => control.get('isCashCollected').value
      );

      // Update main order level cash collection
      const params = this.addChangeStatusToParams({
        isCashCollectionApplied: hasAnyCashCollection ? 1 : 0,
      });
      this.updateDocWithParams(params);
    }
  }

  onPhlenuCashToggle(event: MatSlideToggleChange) {
    const walletAmount =
      this.selectedDeliveryMethod?.walletAmt ||
      this.selectedDeliveryMethod?.phlenuCashAmount ||
      0;
    if (!walletAmount) {
      setTimeout(() => {
        this.form.get('isPhlenuCashApplied').setValue(false);
        this.form.get('isPhlenuCashApplied').updateValueAndValidity();
      }, 0);
      this._matSnackBar.open('Phlenu Cash is not available', 'OKAY', {
        duration: 4000,
      });
    } else if (walletAmount < 1) {
      setTimeout(() => {
        this.form.get('isPhlenuCashApplied').setValue(false);
        this.form.get('isPhlenuCashApplied').updateValueAndValidity();
      }, 0);
      this._matSnackBar.open('Insufficient Phlenu Cash balance', 'OKAY', {
        duration: 4000,
      });
    } else {
      const params = {
        isPhlenuCashApplied: event.checked && walletAmount ? 1 : 0,
        changeStatus: 1,
      };
      this.updateDocWithParams(params);
    }
  }

  // New method to handle delivery fee subtraction toggle
  onSubtractDeliveryFeeChange(event: any) {
    this.subtractDeliveryFee = event.checked;
    this.updateSubtractionSettingsOnFirebase();
  }

  // New method to handle pickup fee subtraction toggle
  onSubtractPickupFeeChange(event: any) {
    this.subtractPickupFee = event.checked;
    this.updateSubtractionSettingsOnFirebase();
  }

  // Update subtraction settings in Firebase (order-level settings)
  updateSubtractionSettingsOnFirebase() {
    const updateParams = this.addChangeStatusToParams({
      isSubtractPriceFromDeliveryFee: this.subtractDeliveryFee ? 1 : 0,
      isSubtractPriceFromPickUpFee: this.subtractPickupFee ? 1 : 0,
    });
    console.log('Updating subtraction settings:', updateParams);
    this.updateDocWithParams(updateParams);
  }

  shouldShowPaymentMethod(): boolean {
    return (
      this.pool?.paymentDirection === 0 ||
      this.pool?.paymentDirection === 1 ||
      this.pool?.paymentDirection === 2
    );
  }

  // Add the cash service selection method
  onSelectCashSerive(selectedIndex) {
    this.selectLogic(this.cashSerive, selectedIndex);
    console.log('this.cashSerive===>==>=>', this.cashSerive);
    this.selectedCashService = this.cashSerive.filter(
      (item) => item.isSelected
    )[0];
    console.log('this.selectedCashService', this.selectedCashService);

    this.saveDataInfoLocal();
  }

  getPaymentMethod() {
    if (this.pool?.paymentDirection == 1) {
      return this.paymentMethods.filter((_, index) => index == 0);
    } else if (this.cashCollection) {
      return this.paymentMethods.filter(
        (_, index) => index !== 1 && index !== 2
      );
    } else {
      return this.paymentMethods.filter((_, index) => index !== 0);
    }
  }

  getDistributionSiteLegend() {
    return true;
  }

  getDropOffLegend(index) {
    if (this.pool?.dropDetails?.[index]?.isDropoffFar == 1) {
      return true;
    }
    return false;
  }

  getPickUpLegend() {
    if (this.pool?.isPickupDSFar == 1) {
      return true;
    }
    return false;
  }

  // Helper method to get individual dropoff fee for a specific location
  getIndividualtotalcharges(index: number): number {
    if (!this.pool?.dropDetails || !this.pool.dropDetails[index]) {
      return 0;
    }
    return this.pool.dropDetails[index].newDropFee || 0;
  }

  // Helper method to check if a specific dropoff has door-to-door delivery
  hasDoorToDoorDropoffAtIndex(index: number): boolean {
    if (!this.pool?.dropDetails || !this.pool.dropDetails[index]) {
      return false;
    }
    return true;
  }
  // Helper method to get dropoff address for a specific location
  getDropoffAddress(index: number): string {
    if (!this.pool?.dropDetails || !this.pool.dropDetails[index]) {
      return '';
    }
    return this.pool.dropDetails[index].address || '';
  }

  // Helper method to get dropoff distance for a specific location
  getDropoffDistance(index: number): number {
    if (!this.pool?.dropDetails || !this.pool.dropDetails[index]) {
      return 0;
    }
    return this.pool.dropDetails[index].distance || 0;
  }

  // Helper method to get dropoff name for a specific location
  getDropoffName(index: number): string {
    if (this.senderType === 'individual') {
      return this.dropoffModel[0]?.contactPerson || 'Drop-off Location';
    } else {
      const dropoffControl = this.dropoffLocations?.controls?.[index];
      return (
        dropoffControl?.get('contactPerson')?.value || `Drop-off ${index + 1}`
      );
    }
  }

  // Add method to handle business-specific package selection
  onSelectPackageForBusiness(i: number, dropIndex: number) {
    if (!this.form || !this.dropoffLocations) {
      console.warn('Form not ready yet, cannot select package for business');
      return;
    }

    // Reset all selections in this dropoff
    const dropoff = this.dropoffLocations.at(dropIndex);
    const packageSizes = dropoff.get('packageSizes').value;

    packageSizes.forEach((item: any, index: number) => {
      item.isSelected = index === i ? 1 : 0;
    });

    // Set the selected package
    dropoff.get('packageSize').setValue(packageSizes[i]);

    // Update business dropoff model
    this.updateBusinessDropoffModel();
    this.syncModelToFirebase();
  }

  // Add method to handle business-specific handling method selection
  selectHandlingMethodsForBusiness(i: number, dropIndex: number) {
    if (!this.form || !this.dropoffLocations) {
      console.warn(
        'Form not ready yet, cannot select handling methods for business'
      );
      return;
    }

    // Reset all selections in this dropoff
    const dropoff = this.dropoffLocations.at(dropIndex);
    const handlingItemsControl = dropoff.get('handlingItems');

    if (!handlingItemsControl) {
      console.warn('handlingItems control not found');
      return;
    }

    const handlingItems = handlingItemsControl.value;
    if (!handlingItems || !Array.isArray(handlingItems)) {
      console.warn('handlingItems is not a valid array');
      return;
    }

    handlingItems.forEach((item: any, index: number) => {
      item.isSelected = index === i ? 1 : 0;
    });

    // Set the selected handling method
    const selectedHandlingItemControl = dropoff.get('selectedHandlingItem');
    if (selectedHandlingItemControl) {
      selectedHandlingItemControl.setValue(handlingItems[i]);
    }

    // Update sub-items based on selection
    this.updateHandlingSubItemsForBusiness(dropIndex, handlingItems[i]);

    // Update business dropoff model
    this.updateBusinessDropoffModel();
    this.syncModelToFirebase();
  }

  // Add method to handle business-specific package item selection
  onSelectPackagedItemForBusiness(i: number, dropIndex: number) {
    if (!this.form || !this.dropoffLocations) {
      console.warn(
        'Form not ready yet, cannot select packaged item for business'
      );
      return;
    }

    // Reset all selections in this dropoff
    const dropoff = this.dropoffLocations.at(dropIndex);
    const handlingSubItemsControl = dropoff.get('handlingSubItems');

    if (!handlingSubItemsControl) {
      console.warn('handlingSubItems control not found');
      return;
    }

    const handlingSubItems = handlingSubItemsControl.value;
    if (!handlingSubItems || !Array.isArray(handlingSubItems)) {
      console.warn('handlingSubItems is not a valid array');
      return;
    }

    handlingSubItems.forEach((item: any, index: number) => {
      item.isSelected = index === i ? 1 : 0;
    });

    // Set the selected sub item
    const selectedSubItemControl = dropoff.get('selectedSubItem');
    if (selectedSubItemControl) {
      selectedSubItemControl.setValue(handlingSubItems[i]);
    }

    // Update business dropoff model
    this.updateBusinessDropoffModel();
    this.syncModelToFirebase();
  }

  // Add method to update handling sub-items for business
  updateHandlingSubItemsForBusiness(
    dropIndex: number,
    selectedHandlingItem: any
  ) {
    if (!this.form || !this.dropoffLocations) {
      console.warn(
        'Form not ready yet, cannot update handling sub items for business'
      );
      return;
    }

    const dropoff = this.dropoffLocations.at(dropIndex);

    // Get sub-items based on selected handling method
    let subItems = [];
    if (selectedHandlingItem && selectedHandlingItem.id) {
      // handlingAllData is an object with package and care properties, not an array
      if (selectedHandlingItem.id === 1) {
        // Packaged items
        subItems = this.addNewKey(this.handlingAllData?.package || []);
      } else if (selectedHandlingItem.id === 2) {
        // Handle with care items
        subItems = this.addNewKey(this.handlingAllData?.care || []);
      }
    }

    const handlingSubItemsControl = dropoff.get('handlingSubItems');
    const selectedSubItemControl = dropoff.get('selectedSubItem');

    if (handlingSubItemsControl) {
      handlingSubItemsControl.setValue(subItems);
    }
    if (selectedSubItemControl) {
      selectedSubItemControl.setValue('');
    }
  }

  // Debug method to check dropoff locations
  debugDropoffLocations() {
    console.log('=== Debug Dropoff Locations ===');
    console.log('Form exists:', !!this.form);
    console.log('DropoffLocations exists:', !!this.dropoffLocations);
    console.log('DropoffLocations length:', this.dropoffLocations?.length);

    if (this.dropoffLocations) {
      this.dropoffLocations.controls.forEach((control, index) => {
        console.log(`Dropoff ${index}:`, {
          address: control.get('dropoffPointAddress')?.value,
          location: control.get('dropoffPoint')?.value,
          contactPerson: control.get('contactPerson')?.value,
          valid: control.valid,
          touched: control.touched,
        });
      });
    }
    console.log('=== End Debug ===');
  }

  // Method to check if a dropoff location can be removed
  canRemoveDropoff(dropIndex: number): boolean {
    return (
      this.dropoffLocations &&
      this.dropoffLocations.controls.length > 2 &&
      dropIndex >= 2
    );
  }

  // Method to validate phone number
  validatePhoneNumber(phoneNumber: string): boolean {
    if (!phoneNumber) return false;
    // Remove any non-digit characters
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    // Check if it's between 10-15 digits
    return cleanNumber.length >= 10 && cleanNumber.length <= 15;
  }

  // Method to format phone number
  formatPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return '';
    // Remove any non-digit characters
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    // Return the clean number
    return cleanNumber;
  }

  // Method to navigate to next location
  goToNextLocation() {
    if (this.selectedIndex < this.dropoffLocations.controls.length - 1) {
      // Try to find next incomplete location
      const nextIncomplete = this.getNextIncompleteLocation();

      if (nextIncomplete > this.selectedIndex) {
        // Go to next incomplete location
        this.selectedIndex = nextIncomplete;
        this._matSnackBar.open(
          `Moved to incomplete location ${this.selectedIndex + 1}`,
          'OK',
          { duration: 1500 }
        );
      } else {
        // Go to next location in sequence
        this.selectedIndex++;
        this._matSnackBar.open(
          `Moved to location ${this.selectedIndex + 1}`,
          'OK',
          { duration: 1500 }
        );
      }

      this.updateDropOff();
    } else {
      // Check if all locations are complete
      const incompleteLocation = this.getNextIncompleteLocation();
      if (incompleteLocation !== -1) {
        this.selectedIndex = incompleteLocation;
        this.updateDropOff();
        this._matSnackBar.open(
          `Moved to incomplete location ${this.selectedIndex + 1}`,
          'OK',
          { duration: 1500 }
        );
      } else {
        this._matSnackBar.open('All locations are complete!', 'OK', {
          duration: 2000,
        });
      }
    }
  }

  // Method to navigate to previous location
  goToPreviousLocation() {
    if (this.selectedIndex > 0) {
      this.selectedIndex--;
      this.updateDropOff();

      // Show feedback to user
      this._matSnackBar.open(
        `Moved to location ${this.selectedIndex + 1}`,
        'OK',
        { duration: 1500 }
      );
    }
  }

  // Method to check if current location is complete
  isLocationComplete(dropIndex: number): boolean {
    if (!this.dropoffLocations || !this.dropoffLocations.controls[dropIndex]) {
      return false;
    }

    const dropoff = this.dropoffLocations.controls[dropIndex];
    return dropoff.valid && dropoff.touched;
  }

  // Method to get next incomplete location
  getNextIncompleteLocation(): number {
    for (let i = 0; i < this.dropoffLocations.controls.length; i++) {
      if (!this.isLocationComplete(i)) {
        return i;
      }
    }
    return -1; // All locations are complete
  }

  // Method to add new dropoff location and navigate to it
  addNewLocationAndNavigate() {
    this.incrementDropoff();
    this.selectedIndex = this.dropoffLocations.controls.length - 1;
    this.updateDropOff();
    this._matSnackBar.open(
      `Added new location ${this.selectedIndex + 1}`,
      'OK',
      { duration: 1500 }
    );
  }

  // Method to get selected handling method for business review
  getSelectedHandlingMethod(dropoffIndex: number): string {
    if (!this.dropoffLocations || !this.dropoffLocations.at(dropoffIndex)) {
      return '';
    }

    const dropoff = this.dropoffLocations.at(dropoffIndex);
    const selectedHandlingItem = dropoff.get('selectedHandlingItem')?.value;

    if (selectedHandlingItem && selectedHandlingItem.title) {
      return selectedHandlingItem.title;
    }

    // Fallback: check if any handling item is selected
    const handlingItems = dropoff.get('handlingItems')?.value || [];
    const selectedItem = handlingItems.find(
      (item: any) => item.isSelected === 1
    );

    return selectedItem ? selectedItem.title : '';
  }

  // Method to get selected package size for business review
  getSelectedPackageSize(dropoffIndex: number): string {
    if (!this.dropoffLocations || !this.dropoffLocations.at(dropoffIndex)) {
      return '';
    }

    const dropoff = this.dropoffLocations.at(dropoffIndex);
    const selectedPackageSize = dropoff.get('packageSize')?.value;

    if (selectedPackageSize && selectedPackageSize.name) {
      return selectedPackageSize.name;
    }

    // Fallback: check if any package size is selected
    const packageSizes = dropoff.get('packageSizes')?.value || [];
    const selectedSize = packageSizes.find(
      (item: any) => item.isSelected === 1
    );

    return selectedSize ? selectedSize.name : '';
  }

  // Method to update business security cover for specific dropoff
  updateBusinessSecurityCoverForDropoff(
    dropoffIndex: number,
    isEnabled: boolean
  ) {
    if (!this.dropoffLocations || !this.dropoffLocations.at(dropoffIndex)) {
      console.warn(`Dropoff at index ${dropoffIndex} not found`);
      return;
    }

    const dropoff = this.dropoffLocations.at(dropoffIndex);
    dropoff.get('isSecurityCoverApplied').setValue(isEnabled);

    // Update the tracking state
    this.isBusinessSecurityCoverApplied[dropoffIndex] = isEnabled;

    console.log(`Updating security cover for dropoff ${dropoffIndex}:`, {
      isEnabled: isEnabled,
      currentDropoffModel: this.dropoffModel[dropoffIndex],
      formValue: dropoff.get('isSecurityCoverApplied').value,
      trackingState: this.isBusinessSecurityCoverApplied[dropoffIndex],
    });

    // Update the specific dropoff in the model immediately
    if (this.dropoffModel[dropoffIndex]) {
      this.dropoffModel[dropoffIndex].isSecurityCoverApplied = isEnabled
        ? 1
        : 0;
      this.dropoffModel[dropoffIndex].isCoverEnabled = isEnabled ? 1 : 0;

      console.log(`Updated dropoff model ${dropoffIndex}:`, {
        isSecurityCoverApplied:
          this.dropoffModel[dropoffIndex].isSecurityCoverApplied,
        isCoverEnabled: this.dropoffModel[dropoffIndex].isCoverEnabled,
        preservedLocation: this.dropoffModel[dropoffIndex].location,
      });
    } else {
      // If dropoff model doesn't exist, create it
      this.dropoffModel[dropoffIndex] = this.createDropoffModel(dropoffIndex);
      this.dropoffModel[dropoffIndex].isSecurityCoverApplied = isEnabled
        ? 1
        : 0;
      this.dropoffModel[dropoffIndex].isCoverEnabled = isEnabled ? 1 : 0;
    }

    // Sync to Firebase immediately (without calling updateSpecificDropoffInModel)
    this.syncModelToFirebase();

    // Trigger payment summary update
    this.handlePaymentSummaryUpdate();

    // Show feedback to user
    const message = isEnabled
      ? `Security cover enabled for dropoff location ${dropoffIndex + 1}`
      : `Security cover disabled for dropoff location ${dropoffIndex + 1}`;
    this._matSnackBar.open(message, 'OK', { duration: 2000 });
  }

  // Add this method after the ngOnInit method
  filterDeliveryMethodByCountry() {
    this.countries.map((country) => {
      if (country.title == localStorage.getItem('country')) {
        country.selected = 1;
        this.selectedCountryCode = country.code;
      } else {
        country.selected = 0;
      }
    });

    // derive selectedCountry for messaging/validation
    const storedCountry = localStorage.getItem('country');
    if (storedCountry && storedCountry.trim()) {
      this.selectedCountry = storedCountry.trim();
    } else {
      this.selectedCountry =
        this.selectedCountryCode === '+233' ? 'Ghana' : 'Nigeria';
    }

    if (localStorage.getItem('country'))
      if (localStorage.getItem('country') == 'Nigeria') {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 2 || method.id === 3 || method.id === 4
        );
      } else {
        this.deliveryMethods = this.deliveryMethods.filter(
          (method) => method.id === 1 || method.id === 2 || method.id === 3
        );
      }
  }

  // Add this method for handling country changes
  changeCountry() {
    // This method can be called when country selection changes
    // For now, we'll just update the validation patterns
    this.updatePhoneValidation();
  }

  // Add this method to update phone validation based on country
  updatePhoneValidation() {
    this.dropoffLocations.controls.forEach((control, index) => {
      const phoneControl = control.get('personNumber');
      if (phoneControl) {
        const pattern =
          this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}';
        phoneControl.setValidators([
          Validators.required,
          Validators.pattern(pattern),
        ]);
        phoneControl.updateValueAndValidity();
      }
    });
  }

  // Add these validation methods from bulk order
  checkZeroNumber(value, dropIndex) {
    if (String(value).split('')[0] == '0') {
      this.dropoffLocations.controls[dropIndex]
        .get('personNumber')
        ?.setValidators([
          Validators.pattern(
            this.selectedCountryCode == '+233' ? '[0-9]{10,10}' : '[0-9]{11,11}'
          ),
          Validators.required,
        ]);
      return true;
    } else {
      this.dropoffLocations.controls[dropIndex]
        .get('personNumber')
        ?.setValidators([
          Validators.pattern(
            this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
          ),
          Validators.required,
        ]);
      return false;
    }
  }

  checkZeroNumberPickup(value) {
    if (String(value).split('')[0] == '0') {
      return true;
    } else {
      return false;
    }
  }

  phoneNumberTrim(field, i) {
    return this.checkZeroNumber(field, i)
      ? this.selectedCountryCode == '+233'
        ? String(field).split('').slice(1, 10).join('')
        : String(field).split('').slice(1, 11).join('')
      : field;
  }

  phoneNumberTrimPickup(field) {
    return this.checkZeroNumberPickup(field)
      ? this.selectedCountryCode == '+233'
        ? String(field).split('').slice(1, 10).join('')
        : String(field).split('').slice(1, 11).join('')
      : field;
  }

  // Update the onPhoneNumberInput method to use bulk order logic
  onPhoneNumberInput(event: any, dropIndex: number) {
    const value = event.target.value;
    this.checkZeroNumber(value, dropIndex);
    this.dropoffLocations.controls[dropIndex]
      .get('personNumber')
      ?.updateValueAndValidity();
  }

  // Handle dropoff contact details changes and update Firebase
  onDropoffContactChange(dropIndex: number) {
    if (this.senderType === 'business') {
      // Update the business dropoff model and sync with Firebase
      this.updateBusinessDropoffModel();

      // Sync the updated model to Firebase
      if (this.docIdFire) {
        this.syncModelToFirebase();
      }
    }
  }

  // Reset order flow - similar to standard order implementation

  resetOrderFlow() {
    this.hardReload = true;
    const dialog = this._matDialog.open(ConfirmationDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        heading: 'Alert!',
        headingColor: 'text-red',
        message:
          'Proceeding with this action will reset your current order data, and this action cannot be undone. Are you sure you want to proceed?',
        action: {
          ok: 'Continue',
          cancel: 'Cancel',
          align: 'left',
        },
      },
    });

    dialog.afterClosed().subscribe((res) => {
      if (res) {
        localStorage.getItem('PENDINGINTERREGIONALORDERDATA');
        localStorage.removeItem('PENDINGINTERREGIONALORDERDATA');
        window.location.replace(window.location.href);
      } else {
        this.hardReload = false;
      }
    });
  }

  // Attachment methods (from standard order component)
  public onAttachmentSelect(event): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this._authService.uploadFile(file).subscribe((res: any) => {
          if (res.response) {
            this._matSnackBar.open(res.message, 'OKAY', { duration: 2000 });
            this.form.get('attachment').markAsPristine();
            this.form.get('attachment').markAsUntouched();
            this.attachmentUploadedUrl = res.data.url;
            this.isAttachmentUploaded = true;
            this.saveDataInfoLocal();
          }
        });
      };
    }
  }

  public onRemoveAttachment(): void {
    this.form.get('attachment').setValue('');
    this.attachmentUploadedUrl = '';
    this.isAttachmentUploaded = false;
    this.saveDataInfoLocal();
  }

  // Business attachment methods
  public onBusinessAttachmentSelect(event, dropoffIndex: number): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this._authService.uploadFile(file).subscribe((res: any) => {
          if (res.response) {
            this._matSnackBar.open(res.message, 'OKAY', { duration: 2000 });
            const dropoffControl = this.dropoffLocations.controls[dropoffIndex];
            dropoffControl.get('attachment').markAsPristine();
            dropoffControl.get('attachment').markAsUntouched();
            dropoffControl.get('attachmentUrl').setValue(res.data.url);
            dropoffControl.get('isAttachmentUploaded').setValue(true);
            this.saveDataInfoLocal();
          }
        });
      };
    }
  }

  public onRemoveBusinessAttachment(dropoffIndex: number): void {
    const dropoffControl = this.dropoffLocations.controls[dropoffIndex];
    dropoffControl.get('attachment').setValue('');
    dropoffControl.get('attachmentUrl').setValue('');
    dropoffControl.get('isAttachmentUploaded').setValue(false);
    this.saveDataInfoLocal();
  }

  // Method to get all dropoff locations for the dialog (similar to standard order)
  public getAllDropoffLocations(): any[] {
    const allDropoffs = [];
    this.dropoffLocations.controls.forEach((control) => {
      const dropoffPoint = control.get('dropoffPoint').value;
      if (dropoffPoint && dropoffPoint.locationId) {
        allDropoffs.push({
          dropoffPoint: dropoffPoint,
          dropoffPointAddress: control.get('dropoffPointAddress').value,
        });
      }
    });
    return allDropoffs;
  }
}
